/*
 * GENERATED FILE — DO NOT EDIT.
 *
 * Produced by `pnpm api:build-spec` from apps/api/openapi.root.yaml plus every
 * apps/api/src/**‍/openapi.paths.yaml fragment. Edit a fragment and re-run the build; an
 * edit here is overwritten, and `spec.test.ts` fails while this file and the fragments
 * disagree.
 */
import { API_ERROR_CODE } from "./operations.js";
/** The error envelope, thrown by `assertOk`. */
export class ApiError extends Error {
    name = "ApiError";
    code;
    status;
    field;
    requestId;
    constructor(status, body, requestId) {
        const envelope = body?.error;
        const code = typeof envelope?.code === "string" ? envelope.code : "unknown_code";
        super(typeof envelope?.message === "string" ? envelope.message : `HTTP ${status}`);
        this.status = status;
        this.code = API_ERROR_CODE.includes(code)
            ? code
            : "unknown_code";
        this.field = typeof envelope?.field === "string" ? envelope.field : null;
        this.requestId = requestId;
    }
}
/** Raises on any non-2xx, with the documented code. Never returns a partial result. */
export function assertOk(result) {
    if (result.status >= 200 && result.status < 300)
        return result.body;
    throw new ApiError(result.status, result.body, result.requestId);
}
/**
 * The generated client.
 *
 * One method per documented operation, and no generic escape hatch on the public surface:
 * `send` is protected, so a caller cannot reach an endpoint the spec does not carry.
 */
export class WeTalkApiClient {
    #settings;
    constructor(settings) {
        this.#settings = settings;
    }
    /** `POST /v1/staff/optimisation-reviews/{optimisation_review_id}/absorb` — operationId `absorbStaffOptimisationReview`. */
    async absorbStaffOptimisationReview(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/optimisation-reviews/${encodeURIComponent(request.path["optimisation_review_id"])}/absorb`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/invitations/accept` — operationId `acceptAccountInvitation`. */
    async acceptAccountInvitation(request) {
        return this.send({
            method: "POST",
            path: "/v1/invitations/accept",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/terms-acceptance` — operationId `acceptAccountTerms`. */
    async acceptAccountTerms(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/terms-acceptance`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/me/domain-join-offers/{offer_id}/accept` — operationId `acceptDomainJoinOffer`. */
    async acceptDomainJoinOffer(request) {
        return this.send({
            method: "POST",
            path: `/v1/me/domain-join-offers/${encodeURIComponent(request.path["offer_id"])}/accept`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/invitation/accept` — operationId `acceptInvitation`. */
    async acceptInvitation(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/invitation/accept",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/resource-shares/{resource_share_id}/accept` — operationId `acceptResourceShare`. */
    async acceptResourceShare(request) {
        return this.send({
            method: "POST",
            path: `/v1/resource-shares/${encodeURIComponent(request.path["resource_share_id"])}/accept`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/conversations/{conversation_id}/recording/access` — operationId `accessConversationRecording`. */
    async accessConversationRecording(request) {
        return this.send({
            method: "POST",
            path: `/v1/conversations/${encodeURIComponent(request.path["conversation_id"])}/recording/access`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/blocked-numbers` — operationId `addBlockedNumber`. */
    async addBlockedNumber(request) {
        return this.send({
            method: "POST",
            path: "/v1/blocked-numbers",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/contact-lists/{contact_list_id}/contacts` — operationId `addContactListContacts`. */
    async addContactListContacts(request) {
        return this.send({
            method: "POST",
            path: `/v1/contact-lists/${encodeURIComponent(request.path["contact_list_id"])}/contacts`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/do-not-call-entries` — operationId `addDoNotCallEntry`. */
    async addDoNotCallEntry(request) {
        return this.send({
            method: "POST",
            path: "/v1/do-not-call-entries",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/sip-trunks/{sip_trunk_id}/numbers` — operationId `addSipTrunkNumber`. */
    async addSipTrunkNumber(request) {
        return this.send({
            method: "POST",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/numbers`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/notes` — operationId `addStaffAccountNote`. */
    async addStaffAccountNote(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/notes`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/do-not-call` — operationId `addStaffDoNotCallEntry`. */
    async addStaffDoNotCallEntry(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/do-not-call",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/capacity/replica/add` — operationId `addStaffGpuReplica`. */
    async addStaffGpuReplica(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/capacity/replica/add",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/access/entries` — operationId `addVoiceAgentAccessEntry`. */
    async addVoiceAgentAccessEntry(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/access/entries`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/shop/{counter_access_key}/order/{customer_order_reference}/advance` — operationId `advanceShopBoardCustomerOrder`. */
    async advanceShopBoardCustomerOrder(request) {
        return this.send({
            method: "POST",
            path: `/v1/shop/${encodeURIComponent(request.path["counter_access_key"])}/order/${encodeURIComponent(request.path["customer_order_reference"])}/advance`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/finance/bank-allocations` — operationId `allocateStaffBankTransfer`. */
    async allocateStaffBankTransfer(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/finance/bank-allocations",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/gaps/{gap_id}/answer` — operationId `answerGap`. */
    async answerGap(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/gaps/${encodeURIComponent(request.path["gap_id"])}/answer`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/me/mfa/challenge` — operationId `answerMyMfaChallenge`. */
    async answerMyMfaChallenge(request) {
        return this.send({
            method: "POST",
            path: "/v1/me/mfa/challenge",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/approval-requests/{approval_request_id}/apply` — operationId `applyStaffApprovalRequest`. */
    async applyStaffApprovalRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/approval-requests/${encodeURIComponent(request.path["approval_request_id"])}/apply`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/approval-requests/{approval_request_id}/approve` — operationId `approveStaffApprovalRequest`. */
    async approveStaffApprovalRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/approval-requests/${encodeURIComponent(request.path["approval_request_id"])}/approve`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/runs/{payout_run_id}/approve` — operationId `approveStaffPayoutRun`. */
    async approveStaffPayoutRun(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/runs/${encodeURIComponent(request.path["payout_run_id"])}/approve`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/finance/refund-requests/{billing_operation_id}/approve` — operationId `approveStaffRefundRequest`. */
    async approveStaffRefundRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/finance/refund-requests/${encodeURIComponent(request.path["billing_operation_id"])}/approve`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/archive` — operationId `archiveVoiceAgent`. */
    async archiveVoiceAgent(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/archive`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/workspaces/{workspace_id}/archive` — operationId `archiveWorkspaceWithPreflight`. */
    async archiveWorkspaceWithPreflight(request) {
        return this.send({
            method: "POST",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/archive`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/finance/operations/{billing_operation_id}/ask-provider` — operationId `askStaffFinanceProvider`. */
    async askStaffFinanceProvider(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/finance/operations/${encodeURIComponent(request.path["billing_operation_id"])}/ask-provider`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/phone-numbers` — operationId `assignPlatformPhoneNumber`. */
    async assignPlatformPhoneNumber(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/phone-numbers`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/requests/{help_request_id}/assignment` — operationId `assignStaffHelpRequest`. */
    async assignStaffHelpRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/requests/${encodeURIComponent(request.path["help_request_id"])}/assignment`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/resource-shares/{resource_share_id}/attach` — operationId `attachResourceShare`. */
    async attachResourceShare(request) {
        return this.send({
            method: "POST",
            path: `/v1/resource-shares/${encodeURIComponent(request.path["resource_share_id"])}/attach`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/google/start` — operationId `beginGoogleSignIn`. */
    async beginGoogleSignIn(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/google/start",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/microsoft/start` — operationId `beginMicrosoftSignIn`. */
    async beginMicrosoftSignIn(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/microsoft/start",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/session/step-up/provider` — operationId `beginProviderStepUp`. */
    async beginProviderStepUp(request) {
        return this.send({
            method: "POST",
            path: "/v1/session/step-up/provider",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/sip-trunks/{sip_trunk_id}/numbers/{phone_number_id}/binding` — operationId `bindSipTrunkNumber`. */
    async bindSipTrunkNumber(request) {
        return this.send({
            method: "PUT",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/numbers/${encodeURIComponent(request.path["phone_number_id"])}/binding`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/conversations/{conversation_id}/block-number` — operationId `blockConversationNumber`. */
    async blockConversationNumber(request) {
        return this.send({
            method: "POST",
            path: `/v1/conversations/${encodeURIComponent(request.path["conversation_id"])}/block-number`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/people/{person_id}/block` — operationId `blockStaffPerson`. */
    async blockStaffPerson(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/people/${encodeURIComponent(request.path["person_id"])}/block`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/billing-operations/{billing_operation_id}/cancel` — operationId `cancelBillingOperation`. */
    async cancelBillingOperation(request) {
        return this.send({
            method: "POST",
            path: `/v1/billing-operations/${encodeURIComponent(request.path["billing_operation_id"])}/cancel`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/orders/{customer_order_reference}/payment-link/cancel` — operationId `cancelCustomerOrderPaymentLink`. */
    async cancelCustomerOrderPaymentLink(request) {
        return this.send({
            method: "POST",
            path: `/v1/orders/${encodeURIComponent(request.path["customer_order_reference"])}/payment-link/cancel`,
            query: request.query,
            body: request.body,
            header: request.header,
        });
    }
    /** `DELETE /v1/orders-api/api/orders/{customer_order_reference}` — operationId `cancelPortedCustomerOrder`. */
    async cancelPortedCustomerOrder(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/orders-api/api/orders/${encodeURIComponent(request.path["customer_order_reference"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/confirmation-code-prices/changes/{account_confirmation_code_price_id}/cancel` — operationId `cancelStaffAccountConfirmationCodePriceChange`. */
    async cancelStaffAccountConfirmationCodePriceChange(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/confirmation-code-prices/changes/${encodeURIComponent(request.path["account_confirmation_code_price_id"])}/cancel`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/talk-rates/changes/{talk_rate_change_id}/cancel` — operationId `cancelStaffAccountTalkRateChange`. */
    async cancelStaffAccountTalkRateChange(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/talk-rates/changes/${encodeURIComponent(request.path["talk_rate_change_id"])}/cancel`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/confirmation-code-prices/changes/{standard_confirmation_code_price_id}/cancel` — operationId `cancelStaffConfirmationCodePriceChange`. */
    async cancelStaffConfirmationCodePriceChange(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/confirmation-code-prices/changes/${encodeURIComponent(request.path["standard_confirmation_code_price_id"])}/cancel`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/optimisation-reviews/{optimisation_review_id}/cancel` — operationId `cancelStaffOptimisationReview`. */
    async cancelStaffOptimisationReview(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/optimisation-reviews/${encodeURIComponent(request.path["optimisation_review_id"])}/cancel`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/runs/{payout_run_id}/cancel` — operationId `cancelStaffPayoutRun`. */
    async cancelStaffPayoutRun(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/runs/${encodeURIComponent(request.path["payout_run_id"])}/cancel`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/talk-rates/changes/{talk_rate_change_id}/cancel` — operationId `cancelStaffStandardTalkRateChange`. */
    async cancelStaffStandardTalkRateChange(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/talk-rates/changes/${encodeURIComponent(request.path["talk_rate_change_id"])}/cancel`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/subscription/cancel` — operationId `cancelStaffSubscription`. */
    async cancelStaffSubscription(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/subscription/cancel`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/workspaces/{workspace_id}/lifecycle-operations/{workspace_lifecycle_operation_id}/cancel` — operationId `cancelWorkspaceArchive`. */
    async cancelWorkspaceArchive(request) {
        return this.send({
            method: "POST",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/lifecycle-operations/${encodeURIComponent(request.path["workspace_lifecycle_operation_id"])}/cancel`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/me/password` — operationId `changeMyPassword`. */
    async changeMyPassword(request) {
        return this.send({
            method: "POST",
            path: "/v1/me/password",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/requests/{help_request_id}/state` — operationId `changeStaffHelpRequestState`. */
    async changeStaffHelpRequestState(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/requests/${encodeURIComponent(request.path["help_request_id"])}/state`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/sip-trunks/{sip_trunk_id}/check` — operationId `checkSipTrunk`. */
    async checkSipTrunk(request) {
        return this.send({
            method: "POST",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/check`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/capacity/model-backup/check` — operationId `checkStaffModelBackup`. */
    async checkStaffModelBackup(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/capacity/model-backup/check",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/capacity/second-model-backup/check` — operationId `checkStaffSecondModelBackup`. */
    async checkStaffSecondModelBackup(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/capacity/second-model-backup/check",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/sip-trunks/{sip_trunk_id}/check` — operationId `checkStaffSipTrunk`. */
    async checkStaffSipTrunk(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/check`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/questionnaire-document/check` — operationId `checkVoiceAgentQuestionnaireDocument`. */
    async checkVoiceAgentQuestionnaireDocument(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/questionnaire-document/check`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/capacity/{gpu_pool_id}/window/close` — operationId `closeStaffGpuWindow`. */
    async closeStaffGpuWindow(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/capacity/${encodeURIComponent(request.path["gpu_pool_id"])}/window/close`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/billing/payment-methods/card-purchase` — operationId `completeCardPurchase`. */
    async completeCardPurchase(request) {
        return this.send({
            method: "POST",
            path: "/v1/billing/payment-methods/card-purchase",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/documents/{agent_document_id}/confirm` — operationId `confirmAgentDocument`. */
    async confirmAgentDocument(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/documents/${encodeURIComponent(request.path["agent_document_id"])}/confirm`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/billing-operations` — operationId `confirmBillingOperation`. */
    async confirmBillingOperation(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/billing-operations`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/document-previews/{document_preview_id}/confirm` — operationId `confirmDocumentPreview`. */
    async confirmDocumentPreview(request) {
        return this.send({
            method: "POST",
            path: `/v1/document-previews/${encodeURIComponent(request.path["document_preview_id"])}/confirm`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/me/email-changes/confirm` — operationId `confirmMyEmailChange`. */
    async confirmMyEmailChange(request) {
        return this.send({
            method: "POST",
            path: "/v1/me/email-changes/confirm",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/me/mfa/totp/confirm` — operationId `confirmMyTotpEnrolment`. */
    async confirmMyTotpEnrolment(request) {
        return this.send({
            method: "POST",
            path: "/v1/me/mfa/totp/confirm",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/operator-action-confirmations/confirm` — operationId `confirmOperatorAction`. */
    async confirmOperatorAction(request) {
        return this.send({
            method: "POST",
            path: "/v1/operator-action-confirmations/confirm",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/auth/totp-enrolment/confirm` — operationId `confirmOperatorTotpEnrolment`. */
    async confirmOperatorTotpEnrolment(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/auth/totp-enrolment/confirm",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/password-reset/confirm` — operationId `confirmPasswordReset`. */
    async confirmPasswordReset(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/password-reset/confirm",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/provider/confirm` — operationId `confirmProviderSignIn`. */
    async confirmProviderSignIn(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/provider/confirm",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/public/status/subscriptions/confirmation` — operationId `confirmStatusSubscription`. */
    async confirmStatusSubscription(request) {
        return this.send({
            method: "POST",
            path: "/v1/public/status/subscriptions/confirmation",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/bi-connections` — operationId `connectBiSource`. */
    async connectBiSource(request) {
        return this.send({
            method: "POST",
            path: "/v1/bi-connections",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/messaging/media/{medium_code}/connection` — operationId `connectMessagingMedium`. */
    async connectMessagingMedium(request) {
        return this.send({
            method: "POST",
            path: `/v1/messaging/media/${encodeURIComponent(request.path["medium_code"])}/connection`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/accounts` — operationId `createAccount`. */
    async createAccount(request) {
        return this.send({
            method: "POST",
            path: "/v1/accounts",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/accounts/{account_id}/allowed-networks` — operationId `createAccountAllowedNetwork`. */
    async createAccountAllowedNetwork(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/allowed-networks`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/api-keys` — operationId `createAccountApiKey`. */
    async createAccountApiKey(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/api-keys`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/accounts/{account_id}/invitations` — operationId `createAccountInvitation`. */
    async createAccountInvitation(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/invitations`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/verified-domains` — operationId `createAccountVerifiedDomain`. */
    async createAccountVerifiedDomain(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/verified-domains`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/workspaces` — operationId `createAccountWorkspace`. */
    async createAccountWorkspace(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/workspaces`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/documents` — operationId `createAgentDocumentUpload`. */
    async createAgentDocumentUpload(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/documents`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/api-keys` — operationId `createApiKey`. */
    async createApiKey(request) {
        return this.send({
            method: "POST",
            path: "/v1/api-keys",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/auth/app-authorization-codes` — operationId `createAppAuthorizationCode`. */
    async createAppAuthorizationCode(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/app-authorization-codes",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/billing-quotes` — operationId `createBillingQuote`. */
    async createBillingQuote(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/billing-quotes`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/browser-test-calls` — operationId `createBrowserTestCall`. */
    async createBrowserTestCall(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/browser-test-calls`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/campaigns` — operationId `createCampaign`. */
    async createCampaign(request) {
        return this.send({
            method: "POST",
            path: "/v1/campaigns",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/connections` — operationId `createConnection`. */
    async createConnection(request) {
        return this.send({
            method: "POST",
            path: "/v1/connections",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/contact-lists` — operationId `createContactList`. */
    async createContactList(request) {
        return this.send({
            method: "POST",
            path: "/v1/contact-lists",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/orders` — operationId `createCustomerOrder`. */
    async createCustomerOrder(request) {
        return this.send({
            method: "POST",
            path: "/v1/orders",
            query: request.query,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/document-previews` — operationId `createDocumentPreviewUpload`. */
    async createDocumentPreviewUpload(request) {
        return this.send({
            method: "POST",
            path: "/v1/document-previews",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/voices/{voice_id}/greeting-sample` — operationId `createGreetingSample`. */
    async createGreetingSample(request) {
        return this.send({
            method: "POST",
            path: `/v1/voices/${encodeURIComponent(request.path["voice_id"])}/greeting-sample`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/help/grants` — operationId `createHelpGrant`. */
    async createHelpGrant(request) {
        return this.send({
            method: "POST",
            path: "/v1/help/grants",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/help/requests` — operationId `createHelpRequest`. */
    async createHelpRequest(request) {
        return this.send({
            method: "POST",
            path: "/v1/help/requests",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/billing/payment-methods/hosted-form` — operationId `createHostedCardForm`. */
    async createHostedCardForm(request) {
        return this.send({
            method: "POST",
            path: "/v1/billing/payment-methods/hosted-form",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `GET /v1/auth/challenge` — operationId `createIdentityChallenge`. */
    async createIdentityChallenge() {
        return this.send({
            method: "GET",
            path: "/v1/auth/challenge",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/optimisation-reviews` — operationId `createOptimisationReview`. */
    async createOptimisationReview(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/optimisation-reviews`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/public/opt-out/{business_slug}` — operationId `createOptOutRequest`. */
    async createOptOutRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/public/opt-out/${encodeURIComponent(request.path["business_slug"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/compliance/person-data-requests` — operationId `createPersonDataRequest`. */
    async createPersonDataRequest(request) {
        return this.send({
            method: "POST",
            path: "/v1/compliance/person-data-requests",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/orders-api/api/coupons` — operationId `createPortedCoupon`. */
    async createPortedCoupon(request) {
        return this.send({
            method: "POST",
            path: "/v1/orders-api/api/coupons",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/orders-api/api/orders` — operationId `createPortedCustomerOrder`. */
    async createPortedCustomerOrder(request) {
        return this.send({
            method: "POST",
            path: "/v1/orders-api/api/orders",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `GET /v1/public/help/challenge` — operationId `createPublicHelpChallenge`. */
    async createPublicHelpChallenge() {
        return this.send({
            method: "GET",
            path: "/v1/public/help/challenge",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/public/help/grants` — operationId `createPublicHelpGrant`. */
    async createPublicHelpGrant(request) {
        return this.send({
            method: "POST",
            path: "/v1/public/help/grants",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/public/help/requests` — operationId `createPublicHelpRequest`. */
    async createPublicHelpRequest(request) {
        return this.send({
            method: "POST",
            path: "/v1/public/help/requests",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/billing-accounts/{billing_account_id}/refund-requests` — operationId `createRefundRequest`. */
    async createRefundRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/billing-accounts/${encodeURIComponent(request.path["billing_account_id"])}/refund-requests`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/workspaces/{workspace_id}/resource-shares` — operationId `createResourceShare`. */
    async createResourceShare(request) {
        return this.send({
            method: "POST",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/resource-shares`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/sandbox-turns` — operationId `createSandboxTurn`. */
    async createSandboxTurn(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/sandbox-turns`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/sip-trunks` — operationId `createSipTrunk`. */
    async createSipTrunk(request) {
        return this.send({
            method: "POST",
            path: "/v1/sip-trunks",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/sip-trunks/{sip_trunk_id}/inbound-auth` — operationId `createSipTrunkInboundAuth`. */
    async createSipTrunkInboundAuth(request) {
        return this.send({
            method: "POST",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/inbound-auth`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/sip-trunks/{sip_trunk_id}/test-calls` — operationId `createSipTrunkTestCall`. */
    async createSipTrunkTestCall(request) {
        return this.send({
            method: "POST",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/test-calls`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/account-creations` — operationId `createStaffAccount`. */
    async createStaffAccount(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/account-creations",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/finance/accounting-exports` — operationId `createStaffAccountingExport`. */
    async createStaffAccountingExport(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/finance/accounting-exports",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/accounts/{account_id}/adjustments` — operationId `createStaffPayableAdjustment`. */
    async createStaffPayableAdjustment(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/accounts/${encodeURIComponent(request.path["account_id"])}/adjustments`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/runs` — operationId `createStaffPayoutRun`. */
    async createStaffPayoutRun(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/payouts/runs",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/status/incidents` — operationId `createStaffStatusIncident`. */
    async createStaffStatusIncident(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/status/incidents",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/billing/payment-methods/subscription-form` — operationId `createSubscriptionCardForm`. */
    async createSubscriptionCardForm(request) {
        return this.send({
            method: "POST",
            path: "/v1/billing/payment-methods/subscription-form",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/survey-rounds/{survey_round_id}/exports` — operationId `createSurveyResultExport`. */
    async createSurveyResultExport(request) {
        return this.send({
            method: "POST",
            path: `/v1/survey-rounds/${encodeURIComponent(request.path["survey_round_id"])}/exports`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/test-calls` — operationId `createTestCall`. */
    async createTestCall(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/test-calls`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/billing/top-ups` — operationId `createTopUp`. */
    async createTopUp(request) {
        return this.send({
            method: "POST",
            path: "/v1/billing/top-ups",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/agents` — operationId `createVoiceAgent`. */
    async createVoiceAgent(request) {
        return this.send({
            method: "POST",
            path: "/v1/agents",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/survey-results/exports` — operationId `createVoiceAgentSurveyExport`. */
    async createVoiceAgentSurveyExport(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/survey-results/exports`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/webhook-endpoints` — operationId `createWebhookEndpoint`. */
    async createWebhookEndpoint(request) {
        return this.send({
            method: "POST",
            path: "/v1/webhook-endpoints",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/public/widget-voice/{widget_key}/grants` — operationId `createWidgetVoiceGrant`. */
    async createWidgetVoiceGrant(request) {
        return this.send({
            method: "POST",
            path: `/v1/public/widget-voice/${encodeURIComponent(request.path["widget_key"])}/grants`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/workspaces` — operationId `createWorkspace`. */
    async createWorkspace(request) {
        return this.send({
            method: "POST",
            path: "/v1/workspaces",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/workspaces/{workspace_id}/api-keys` — operationId `createWorkspaceApiKey`. */
    async createWorkspaceApiKey(request) {
        return this.send({
            method: "POST",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/api-keys`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/subscription/periods/{billing_subscription_period_id}/credit` — operationId `creditStaffSubscriptionPeriod`. */
    async creditStaffSubscriptionPeriod(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/subscription/periods/${encodeURIComponent(request.path["billing_subscription_period_id"])}/credit`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/optimisation-reviews/{optimisation_review_id}/findings/{optimisation_finding_id}/decision` — operationId `decideOptimisationFinding`. */
    async decideOptimisationFinding(request) {
        return this.send({
            method: "PUT",
            path: `/v1/optimisation-reviews/${encodeURIComponent(request.path["optimisation_review_id"])}/findings/${encodeURIComponent(request.path["optimisation_finding_id"])}/decision`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/approval-requests/{approval_request_id}/decline` — operationId `declineStaffApprovalRequest`. */
    async declineStaffApprovalRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/approval-requests/${encodeURIComponent(request.path["approval_request_id"])}/decline`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/quota-requests/{quota_request_id}/decline` — operationId `declineStaffQuotaRequest`. */
    async declineStaffQuotaRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/quota-requests/${encodeURIComponent(request.path["quota_request_id"])}/decline`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/finance/refund-requests/{billing_operation_id}/decline` — operationId `declineStaffRefundRequest`. */
    async declineStaffRefundRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/finance/refund-requests/${encodeURIComponent(request.path["billing_operation_id"])}/decline`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `DELETE /v1/accounts/{account_id}/allowed-networks/{account_allowed_network_id}` — operationId `deleteAccountAllowedNetwork`. */
    async deleteAccountAllowedNetwork(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/allowed-networks/${encodeURIComponent(request.path["account_allowed_network_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/accounts/{account_id}/verified-domains/{sso_domain_id}` — operationId `deleteAccountVerifiedDomain`. */
    async deleteAccountVerifiedDomain(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/verified-domains/${encodeURIComponent(request.path["sso_domain_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/auth/app-auth-session/push-registration` — operationId `deleteAppPushRegistration`. */
    async deleteAppPushRegistration() {
        return this.send({
            method: "DELETE",
            path: "/v1/auth/app-auth-session/push-registration",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/billing/payment-methods/{payment_method_id}` — operationId `deleteBillingPaymentMethod`. */
    async deleteBillingPaymentMethod(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/billing/payment-methods/${encodeURIComponent(request.path["payment_method_id"])}`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/campaigns/{campaign_id}` — operationId `deleteCampaign`. */
    async deleteCampaign(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/campaigns/${encodeURIComponent(request.path["campaign_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/compliance/consent-lines/{medium}/{language_code}` — operationId `deleteConsentLine`. */
    async deleteConsentLine(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/compliance/consent-lines/${encodeURIComponent(request.path["medium"])}/${encodeURIComponent(request.path["language_code"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/contact-lists/{contact_list_id}` — operationId `deleteContactList`. */
    async deleteContactList(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/contact-lists/${encodeURIComponent(request.path["contact_list_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/orders-api/api/coupons/{coupon_code}` — operationId `deletePortedCoupon`. */
    async deletePortedCoupon(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/orders-api/api/coupons/${encodeURIComponent(request.path["coupon_code"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/sip-trunks/{sip_trunk_id}` — operationId `deleteSipTrunk`. */
    async deleteSipTrunk(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/sip-trunks/{sip_trunk_id}/inbound-auth` — operationId `deleteSipTrunkInboundAuth`. */
    async deleteSipTrunkInboundAuth(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/inbound-auth`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/workspaces/{workspace_id}` — operationId `deleteWorkspace`. */
    async deleteWorkspace(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/sip-trunks/{sip_trunk_id}/disable` — operationId `disableSipTrunk`. */
    async disableSipTrunk(request) {
        return this.send({
            method: "POST",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/disable`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/sip-trunks/{sip_trunk_id}/disable` — operationId `disableStaffSipTrunk`. */
    async disableStaffSipTrunk(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/disable`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/messaging/media/{medium_code}/disconnection` — operationId `disconnectMessagingMedium`. */
    async disconnectMessagingMedium(request) {
        return this.send({
            method: "POST",
            path: `/v1/messaging/media/${encodeURIComponent(request.path["medium_code"])}/disconnection`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/messaging/media/web_chat/widgets/{channel_binding_id}/disconnection` — operationId `disconnectWebChatWidget`. */
    async disconnectWebChatWidget(request) {
        return this.send({
            method: "POST",
            path: `/v1/messaging/media/web_chat/widgets/${encodeURIComponent(request.path["channel_binding_id"])}/disconnection`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/auth/discover` — operationId `discoverIdentity`. */
    async discoverIdentity(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/discover",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/gaps/{gap_id}/dismiss` — operationId `dismissGap`. */
    async dismissGap(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/gaps/${encodeURIComponent(request.path["gap_id"])}/dismiss`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `GET /v1/financial-documents/{financial_document_id}/download` — operationId `downloadFinancialDocument`. */
    async downloadFinancialDocument(request) {
        return this.send({
            method: "GET",
            path: `/v1/financial-documents/${encodeURIComponent(request.path["financial_document_id"])}/download`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/compliance/person-data-requests/{person_data_request_id}/download` — operationId `downloadPersonDataExport`. */
    async downloadPersonDataExport(request) {
        return this.send({
            method: "POST",
            path: `/v1/compliance/person-data-requests/${encodeURIComponent(request.path["person_data_request_id"])}/download`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/edit` — operationId `editVoiceAgent`. */
    async editVoiceAgent(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/edit`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/sip-trunks/{sip_trunk_id}/enable` — operationId `enableSipTrunk`. */
    async enableSipTrunk(request) {
        return this.send({
            method: "POST",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/enable`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/sip-trunks/{sip_trunk_id}/enable` — operationId `enableStaffSipTrunk`. */
    async enableStaffSipTrunk(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/enable`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/app-auth-session/end` — operationId `endAppAuthSession`. */
    async endAppAuthSession(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/app-auth-session/end",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/campaigns/{campaign_id}/end` — operationId `endCampaign`. */
    async endCampaign(request) {
        return this.send({
            method: "POST",
            path: `/v1/campaigns/${encodeURIComponent(request.path["campaign_id"])}/end`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/outbound-conversations/{conversation_id}/end` — operationId `endOutboundConversation`. */
    async endOutboundConversation(request) {
        return this.send({
            method: "POST",
            path: `/v1/outbound-conversations/${encodeURIComponent(request.path["conversation_id"])}/end`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/sip-trunks/{sip_trunk_id}/test-calls/{conversation_id}/end` — operationId `endSipTrunkTestCall`. */
    async endSipTrunkTestCall(request) {
        return this.send({
            method: "POST",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/test-calls/${encodeURIComponent(request.path["conversation_id"])}/end`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/conversations/{conversation_id}/end` — operationId `endStaffHelpConversation`. */
    async endStaffHelpConversation(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/conversations/${encodeURIComponent(request.path["conversation_id"])}/end`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `DELETE /v1/staff/impersonations/{impersonation_grant_id}` — operationId `endStaffImpersonation`. */
    async endStaffImpersonation(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/staff/impersonations/${encodeURIComponent(request.path["impersonation_grant_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/test-calls/{conversation_id}/end` — operationId `endTestCall`. */
    async endTestCall(request) {
        return this.send({
            method: "POST",
            path: `/v1/test-calls/${encodeURIComponent(request.path["conversation_id"])}/end`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/requests/{help_request_id}/erasure` — operationId `eraseStaffHelpRequest`. */
    async eraseStaffHelpRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/requests/${encodeURIComponent(request.path["help_request_id"])}/erasure`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/waitlist-signups/erasure` — operationId `eraseStaffWaitlistSignups`. */
    async eraseStaffWaitlistSignups(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/waitlist-signups/erasure",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/campaigns/estimate` — operationId `estimateCampaign`. */
    async estimateCampaign(request) {
        return this.send({
            method: "POST",
            path: "/v1/campaigns/estimate",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/app-auth-sessions` — operationId `exchangeAppAuthorizationCode`. */
    async exchangeAppAuthorizationCode(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/app-auth-sessions",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/audit-entries/exports` — operationId `exportAccountAuditEntries`. */
    async exportAccountAuditEntries(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/audit-entries/exports`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/audit-entries/exports` — operationId `exportAuditEntries`. */
    async exportAuditEntries(request) {
        return this.send({
            method: "POST",
            path: "/v1/audit-entries/exports",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `GET /v1/contact-lists/{contact_list_id}/export.csv` — operationId `exportContactListCsv`. */
    async exportContactListCsv(request) {
        return this.send({
            method: "GET",
            path: `/v1/contact-lists/${encodeURIComponent(request.path["contact_list_id"])}/export.csv`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/orders/export.csv` — operationId `exportCustomerOrdersCsv`. */
    async exportCustomerOrdersCsv(request) {
        return this.send({
            method: "GET",
            path: "/v1/orders/export.csv",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/do-not-call-entries/exports` — operationId `exportDoNotCallEntries`. */
    async exportDoNotCallEntries(request) {
        return this.send({
            method: "POST",
            path: "/v1/do-not-call-entries/exports",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/accounts/{account_id}/financial-documents/exports` — operationId `exportFinancialDocuments`. */
    async exportFinancialDocuments(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/financial-documents/exports`,
            query: request.query,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/billing-accounts/{billing_account_id}/ledger-entries/exports` — operationId `exportLedgerEntries`. */
    async exportLedgerEntries(request) {
        return this.send({
            method: "POST",
            path: `/v1/billing-accounts/${encodeURIComponent(request.path["billing_account_id"])}/ledger-entries/exports`,
            query: request.query,
            body: request.body,
            header: request.header,
        });
    }
    /** `GET /v1/payouts/export.csv` — operationId `exportPayoutStatement`. */
    async exportPayoutStatement(request) {
        return this.send({
            method: "GET",
            path: "/v1/payouts/export.csv",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/conversations/export.csv` — operationId `exportStaffConversations`. */
    async exportStaffConversations(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/conversations/export.csv",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/do-not-call/export.csv` — operationId `exportStaffDoNotCallEntries`. */
    async exportStaffDoNotCallEntries(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/do-not-call/export.csv",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/auth/google/callback` — operationId `finishGoogleSignIn`. */
    async finishGoogleSignIn(request) {
        return this.send({
            method: "GET",
            path: "/v1/auth/google/callback",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/auth/microsoft/callback` — operationId `finishMicrosoftSignIn`. */
    async finishMicrosoftSignIn(request) {
        return this.send({
            method: "GET",
            path: "/v1/auth/microsoft/callback",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/closures/{account_closure_operation_id}` — operationId `getAccountClosure`. */
    async getAccountClosure(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/closures/${encodeURIComponent(request.path["account_closure_operation_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/closure-preflight` — operationId `getAccountClosurePreflight`. */
    async getAccountClosurePreflight(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/closure-preflight`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}` — operationId `getAccountProfile`. */
    async getAccountProfile(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/security` — operationId `getAccountSecurity`. */
    async getAccountSecurity(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/security`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/versions/{agent_version_id}` — operationId `getAgentVersion`. */
    async getAgentVersion(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/versions/${encodeURIComponent(request.path["agent_version_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing/auto-reload` — operationId `getAutoReloadPolicy`. */
    async getAutoReloadPolicy() {
        return this.send({
            method: "GET",
            path: "/v1/billing/auto-reload",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing-accounts/{billing_account_id}/subscription` — operationId `getBalanceSubscription`. */
    async getBalanceSubscription(request) {
        return this.send({
            method: "GET",
            path: `/v1/billing-accounts/${encodeURIComponent(request.path["billing_account_id"])}/subscription`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing-accounts/{billing_account_id}` — operationId `getBillingAccount`. */
    async getBillingAccount(request) {
        return this.send({
            method: "GET",
            path: `/v1/billing-accounts/${encodeURIComponent(request.path["billing_account_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing/balance` — operationId `getBillingBalance`. */
    async getBillingBalance() {
        return this.send({
            method: "GET",
            path: "/v1/billing/balance",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing-operations/{billing_operation_id}` — operationId `getBillingOperation`. */
    async getBillingOperation(request) {
        return this.send({
            method: "GET",
            path: `/v1/billing-operations/${encodeURIComponent(request.path["billing_operation_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing/budget` — operationId `getBudget`. */
    async getBudget() {
        return this.send({
            method: "GET",
            path: "/v1/billing/budget",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/builds/{build_job_id}` — operationId `getBuildJob`. */
    async getBuildJob(request) {
        return this.send({
            method: "GET",
            path: `/v1/builds/${encodeURIComponent(request.path["build_job_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/campaigns/{campaign_id}` — operationId `getCampaign`. */
    async getCampaign(request) {
        return this.send({
            method: "GET",
            path: `/v1/campaigns/${encodeURIComponent(request.path["campaign_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/compliance` — operationId `getCompliance`. */
    async getCompliance() {
        return this.send({
            method: "GET",
            path: "/v1/compliance",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/connections/{connection_id}` — operationId `getConnection`. */
    async getConnection(request) {
        return this.send({
            method: "GET",
            path: `/v1/connections/${encodeURIComponent(request.path["connection_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/contact-lists/{contact_list_id}` — operationId `getContactList`. */
    async getContactList(request) {
        return this.send({
            method: "GET",
            path: `/v1/contact-lists/${encodeURIComponent(request.path["contact_list_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/conversations/{conversation_id}` — operationId `getConversation`. */
    async getConversation(request) {
        return this.send({
            method: "GET",
            path: `/v1/conversations/${encodeURIComponent(request.path["conversation_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/conversations/{conversation_id}/survey-answers` — operationId `getConversationSurveyAnswer`. */
    async getConversationSurveyAnswer(request) {
        return this.send({
            method: "GET",
            path: `/v1/conversations/${encodeURIComponent(request.path["conversation_id"])}/survey-answers`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/session` — operationId `getCurrentAuthSession`. */
    async getCurrentAuthSession() {
        return this.send({
            method: "GET",
            path: "/v1/session",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/orders/{customer_order_reference}` — operationId `getCustomerOrder`. */
    async getCustomerOrder(request) {
        return this.send({
            method: "GET",
            path: `/v1/orders/${encodeURIComponent(request.path["customer_order_reference"])}`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing-accounts/{billing_account_id}/entitlement-impact` — operationId `getEntitlementImpact`. */
    async getEntitlementImpact(request) {
        return this.send({
            method: "GET",
            path: `/v1/billing-accounts/${encodeURIComponent(request.path["billing_account_id"])}/entitlement-impact`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/entitlements` — operationId `getEntitlements`. */
    async getEntitlements(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/entitlements`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/account/extra-time` — operationId `getExtraTime`. */
    async getExtraTime() {
        return this.send({
            method: "GET",
            path: "/v1/account/extra-time",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/finance-overview` — operationId `getFinanceOverview`. */
    async getFinanceOverview(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/finance-overview`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/help/page-reading` — operationId `getHelpPageReading`. */
    async getHelpPageReading() {
        return this.send({
            method: "GET",
            path: "/v1/help/page-reading",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/help/requests/{help_request_id}` — operationId `getHelpRequest`. */
    async getHelpRequest(request) {
        return this.send({
            method: "GET",
            path: `/v1/help/requests/${encodeURIComponent(request.path["help_request_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/languages/suggestion` — operationId `getLanguageSuggestion`. */
    async getLanguageSuggestion() {
        return this.send({
            method: "GET",
            path: "/v1/languages/suggestion",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/messaging/media/{medium_code}` — operationId `getMessagingMedium`. */
    async getMessagingMedium(request) {
        return this.send({
            method: "GET",
            path: `/v1/messaging/media/${encodeURIComponent(request.path["medium_code"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/push-preferences` — operationId `getMyPushPreferences`. */
    async getMyPushPreferences() {
        return this.send({
            method: "GET",
            path: "/v1/push-preferences",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/numbers/{phone_number_id}/activity` — operationId `getNumberActivity`. */
    async getNumberActivity(request) {
        return this.send({
            method: "GET",
            path: `/v1/numbers/${encodeURIComponent(request.path["phone_number_id"])}/activity`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/numbers/availability` — operationId `getNumberAvailability`. */
    async getNumberAvailability() {
        return this.send({
            method: "GET",
            path: "/v1/numbers/availability",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/me/onboarding-draft` — operationId `getOnboardingDraft`. */
    async getOnboardingDraft() {
        return this.send({
            method: "GET",
            path: "/v1/me/onboarding-draft",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing-operations/{billing_operation_id}/payment` — operationId `getOperationPayment`. */
    async getOperationPayment(request) {
        return this.send({
            method: "GET",
            path: `/v1/billing-operations/${encodeURIComponent(request.path["billing_operation_id"])}/payment`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/session` — operationId `getOperatorSession`. */
    async getOperatorSession() {
        return this.send({
            method: "GET",
            path: "/v1/staff/session",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/auth/state` — operationId `getOperatorSignInState`. */
    async getOperatorSignInState() {
        return this.send({
            method: "GET",
            path: "/v1/staff/auth/state",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/optimisation-reviews/{optimisation_review_id}` — operationId `getOptimisationReview`. */
    async getOptimisationReview(request) {
        return this.send({
            method: "GET",
            path: `/v1/optimisation-reviews/${encodeURIComponent(request.path["optimisation_review_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/optimisation-reviews/quote` — operationId `getOptimisationReviewQuote`. */
    async getOptimisationReviewQuote(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/optimisation-reviews/quote`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/public/opt-out/challenge` — operationId `getOptOutChallenge`. */
    async getOptOutChallenge() {
        return this.send({
            method: "GET",
            path: "/v1/public/opt-out/challenge",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/do-not-call/opt-out-page` — operationId `getOptOutPage`. */
    async getOptOutPage() {
        return this.send({
            method: "GET",
            path: "/v1/do-not-call/opt-out-page",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/outbound-conversations/{conversation_id}` — operationId `getOutboundConversation`. */
    async getOutboundConversation(request) {
        return this.send({
            method: "GET",
            path: `/v1/outbound-conversations/${encodeURIComponent(request.path["conversation_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/orders-api/api/orders/{customer_order_reference}` — operationId `getPortedCustomerOrder`. */
    async getPortedCustomerOrder(request) {
        return this.send({
            method: "GET",
            path: `/v1/orders-api/api/orders/${encodeURIComponent(request.path["customer_order_reference"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/orders-api/api/customers/{phone}` — operationId `getPortedShopCustomer`. */
    async getPortedShopCustomer(request) {
        return this.send({
            method: "GET",
            path: `/v1/orders-api/api/customers/${encodeURIComponent(request.path["phone"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing-accounts/{billing_account_id}/postpaid` — operationId `getPostpaid`. */
    async getPostpaid(request) {
        return this.send({
            method: "GET",
            path: `/v1/billing-accounts/${encodeURIComponent(request.path["billing_account_id"])}/postpaid`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/public/help/status` — operationId `getPublicHelpStatus`. */
    async getPublicHelpStatus() {
        return this.send({
            method: "GET",
            path: "/v1/public/help/status",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/public/pricing` — operationId `getPublicPricing`. */
    async getPublicPricing() {
        return this.send({
            method: "GET",
            path: "/v1/public/pricing",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/public/talk-rates` — operationId `getPublicTalkRates`. */
    async getPublicTalkRates() {
        return this.send({
            method: "GET",
            path: "/v1/public/talk-rates",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing-accounts/{billing_account_id}/refundable` — operationId `getRefundable`. */
    async getRefundable(request) {
        return this.send({
            method: "GET",
            path: `/v1/billing-accounts/${encodeURIComponent(request.path["billing_account_id"])}/refundable`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/numbers/region-latency` — operationId `getRegionLatency`. */
    async getRegionLatency() {
        return this.send({
            method: "GET",
            path: "/v1/numbers/region-latency",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/shop/{counter_access_key}/board` — operationId `getShopBoard`. */
    async getShopBoard(request) {
        return this.send({
            method: "GET",
            path: `/v1/shop/${encodeURIComponent(request.path["counter_access_key"])}/board`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/shop/{shop_id}/wait-time` — operationId `getShopWaitTime`. */
    async getShopWaitTime(request) {
        return this.send({
            method: "GET",
            path: `/v1/shop/${encodeURIComponent(request.path["shop_id"])}/wait-time`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/auth/providers` — operationId `getSignInProviders`. */
    async getSignInProviders() {
        return this.send({
            method: "GET",
            path: "/v1/auth/providers",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/sip-trunks/{sip_trunk_id}` — operationId `getSipTrunk`. */
    async getSipTrunk(request) {
        return this.send({
            method: "GET",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/accounts/{account_id}` — operationId `getStaffAccount`. */
    async getStaffAccount(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/accounts/{account_id}/caller-protection` — operationId `getStaffAccountCallerProtection`. */
    async getStaffAccountCallerProtection(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/caller-protection`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/accounts/{account_id}/changes` — operationId `getStaffAccountChanges`. */
    async getStaffAccountChanges(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/changes`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/accounts/{account_id}/confirmation-code-prices` — operationId `getStaffAccountConfirmationCodePrices`. */
    async getStaffAccountConfirmationCodePrices(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/confirmation-code-prices`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/account-creations/options` — operationId `getStaffAccountCreationOptions`. */
    async getStaffAccountCreationOptions() {
        return this.send({
            method: "GET",
            path: "/v1/staff/account-creations/options",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/accounts/{account_id}/talk-rates` — operationId `getStaffAccountTalkRates`. */
    async getStaffAccountTalkRates(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/talk-rates`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/confirmation-code-prices` — operationId `getStaffConfirmationCodePrices`. */
    async getStaffConfirmationCodePrices() {
        return this.send({
            method: "GET",
            path: "/v1/staff/confirmation-code-prices",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/conversations/{conversation_id}` — operationId `getStaffConversation`. */
    async getStaffConversation(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/conversations/${encodeURIComponent(request.path["conversation_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/finance/accounts/{account_id}` — operationId `getStaffFinanceAccount`. */
    async getStaffFinanceAccount(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/finance/accounts/${encodeURIComponent(request.path["account_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/finance/needs-action` — operationId `getStaffFinanceNeedsAction`. */
    async getStaffFinanceNeedsAction() {
        return this.send({
            method: "GET",
            path: "/v1/staff/finance/needs-action",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/finance/reconciliation` — operationId `getStaffFinanceReconciliation`. */
    async getStaffFinanceReconciliation(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/finance/reconciliation",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/help/attention` — operationId `getStaffHelpAttention`. */
    async getStaffHelpAttention(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/help/attention",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/help/requests/{help_request_id}` — operationId `getStaffHelpRequest`. */
    async getStaffHelpRequest(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/help/requests/${encodeURIComponent(request.path["help_request_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/ops` — operationId `getStaffOps`. */
    async getStaffOps() {
        return this.send({
            method: "GET",
            path: "/v1/staff/ops",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/optimisation-reviews/{optimisation_review_id}` — operationId `getStaffOptimisationReview`. */
    async getStaffOptimisationReview(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/optimisation-reviews/${encodeURIComponent(request.path["optimisation_review_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/people/{person_id}` — operationId `getStaffPerson`. */
    async getStaffPerson(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/people/${encodeURIComponent(request.path["person_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/sip-edge` — operationId `getStaffSipEdge`. */
    async getStaffSipEdge() {
        return this.send({
            method: "GET",
            path: "/v1/staff/sip-edge",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/accounts/{account_id}/sip-trunks/{sip_trunk_id}` — operationId `getStaffSipTrunk`. */
    async getStaffSipTrunk(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/talk-rates` — operationId `getStaffStandardTalkRates`. */
    async getStaffStandardTalkRates() {
        return this.send({
            method: "GET",
            path: "/v1/staff/talk-rates",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/accounts/{account_id}/subscription` — operationId `getStaffSubscription`. */
    async getStaffSubscription(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/subscription`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/agents/{voice_agent_id}/build` — operationId `getStaffVoiceAgentBuild`. */
    async getStaffVoiceAgentBuild(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/agents/${encodeURIComponent(request.path["voice_agent_id"])}/build`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/survey-rounds/{survey_round_id}/result` — operationId `getSurveyResult`. */
    async getSurveyResult(request) {
        return this.send({
            method: "GET",
            path: `/v1/survey-rounds/${encodeURIComponent(request.path["survey_round_id"])}/result`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/talk-rates` — operationId `getTalkRates`. */
    async getTalkRates() {
        return this.send({
            method: "GET",
            path: "/v1/talk-rates",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}` — operationId `getVoiceAgent`. */
    async getVoiceAgent(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/access` — operationId `getVoiceAgentAccess`. */
    async getVoiceAgentAccess(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/access`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/analytics` — operationId `getVoiceAgentAnalytics`. */
    async getVoiceAgentAnalytics(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/analytics`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/answering` — operationId `getVoiceAgentAnswering`. */
    async getVoiceAgentAnswering(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/answering`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/answers` — operationId `getVoiceAgentAnswers`. */
    async getVoiceAgentAnswers(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/answers`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/caller-protection` — operationId `getVoiceAgentCallerProtection`. */
    async getVoiceAgentCallerProtection(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/caller-protection`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/concurrency` — operationId `getVoiceAgentConcurrency`. */
    async getVoiceAgentConcurrency(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/concurrency`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/connection` — operationId `getVoiceAgentConnection`. */
    async getVoiceAgentConnection(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/connection`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/handoff` — operationId `getVoiceAgentHandoff`. */
    async getVoiceAgentHandoff(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/handoff`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/party-confirmation` — operationId `getVoiceAgentPartyConfirmation`. */
    async getVoiceAgentPartyConfirmation(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/party-confirmation`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/pass-targets` — operationId `getVoiceAgentPassTargets`. */
    async getVoiceAgentPassTargets(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/pass-targets`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/questionnaire` — operationId `getVoiceAgentQuestionnaire`. */
    async getVoiceAgentQuestionnaire(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/questionnaire`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/questionnaire-document` — operationId `getVoiceAgentQuestionnaireDocument`. */
    async getVoiceAgentQuestionnaireDocument(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/questionnaire-document`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/questionnaire-document/file` — operationId `getVoiceAgentQuestionnaireFile`. */
    async getVoiceAgentQuestionnaireFile(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/questionnaire-document/file`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/sip` — operationId `getVoiceAgentSip`. */
    async getVoiceAgentSip(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/sip`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/survey-results` — operationId `getVoiceAgentSurveyResult`. */
    async getVoiceAgentSurveyResult(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/survey-results`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/test-suites` — operationId `getVoiceAgentTestSuites`. */
    async getVoiceAgentTestSuites(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/test-suites`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/voices/{voice_id}/sample` — operationId `getVoiceSample`. */
    async getVoiceSample(request) {
        return this.send({
            method: "GET",
            path: `/v1/voices/${encodeURIComponent(request.path["voice_id"])}/sample`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/website-reading` — operationId `getWebsiteReading`. */
    async getWebsiteReading(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/website-reading`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/website-reading/pages/{ordinal}` — operationId `getWebsiteReadingPage`. */
    async getWebsiteReadingPage(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/website-reading/pages/${encodeURIComponent(request.path["ordinal"])}`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/workspaces/{workspace_id}` — operationId `getWorkspace`. */
    async getWorkspace(request) {
        return this.send({
            method: "GET",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/workspaces/{workspace_id}/access-policy` — operationId `getWorkspaceAccessPolicy`. */
    async getWorkspaceAccessPolicy(request) {
        return this.send({
            method: "GET",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/access-policy`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/workspaces/{workspace_id}/archive-preflight` — operationId `getWorkspaceArchivePreflight`. */
    async getWorkspaceArchivePreflight(request) {
        return this.send({
            method: "GET",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/archive-preflight`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/workspace-creation-policy` — operationId `getWorkspaceCreationPolicy`. */
    async getWorkspaceCreationPolicy(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/workspace-creation-policy`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing/funding` — operationId `getWorkspaceFunding`. */
    async getWorkspaceFunding() {
        return this.send({
            method: "GET",
            path: "/v1/billing/funding",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/workspaces/{workspace_id}/lifecycle-operations/{workspace_lifecycle_operation_id}` — operationId `getWorkspaceLifecycleOperation`. */
    async getWorkspaceLifecycleOperation(request) {
        return this.send({
            method: "GET",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/lifecycle-operations/${encodeURIComponent(request.path["workspace_lifecycle_operation_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/workspace/onboarding` — operationId `getWorkspaceOnboarding`. */
    async getWorkspaceOnboarding() {
        return this.send({
            method: "GET",
            path: "/v1/workspace/onboarding",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/workspace/usage-summary` — operationId `getWorkspaceUsageSummary`. */
    async getWorkspaceUsageSummary() {
        return this.send({
            method: "GET",
            path: "/v1/workspace/usage-summary",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/workspace-access-grants` — operationId `grantAccountWorkspaceAccess`. */
    async grantAccountWorkspaceAccess(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/workspace-access-grants`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/credit-grants` — operationId `grantStaffAccountCreditFromWeTalk`. */
    async grantStaffAccountCreditFromWeTalk(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/credit-grants`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/finance/credits` — operationId `grantStaffFinanceCredit`. */
    async grantStaffFinanceCredit(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/finance/credits",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/operators/{operator_id}/capability-grants` — operationId `grantStaffOperatorCapability`. */
    async grantStaffOperatorCapability(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/operators/${encodeURIComponent(request.path["operator_id"])}/capability-grants`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/conversations/{conversation_id}/hand-back` — operationId `handBackStaffHelpConversation`. */
    async handBackStaffHelpConversation(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/conversations/${encodeURIComponent(request.path["conversation_id"])}/hand-back`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/do-not-call-entries/import` — operationId `importDoNotCallEntries`. */
    async importDoNotCallEntries(request) {
        return this.send({
            method: "POST",
            path: "/v1/do-not-call-entries/import",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/payouts/settlement-credits/import` — operationId `importStaffSettlementCredits`. */
    async importStaffSettlementCredits(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/payouts/settlement-credits/import",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/public/status/latency-measurements` — operationId `ingestLatencyMeasurement`. */
    async ingestLatencyMeasurement(request) {
        return this.send({
            method: "POST",
            path: "/v1/public/status/latency-measurements",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/invitations/inspect` — operationId `inspectAccountInvitation`. */
    async inspectAccountInvitation(request) {
        return this.send({
            method: "POST",
            path: "/v1/invitations/inspect",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/contact-lists/inspect` — operationId `inspectContactSource`. */
    async inspectContactSource(request) {
        return this.send({
            method: "POST",
            path: "/v1/contact-lists/inspect",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/invitation/inspect` — operationId `inspectInvitation`. */
    async inspectInvitation(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/invitation/inspect",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/operator-action-confirmations/inspect` — operationId `inspectOperatorActionConfirmation`. */
    async inspectOperatorActionConfirmation(request) {
        return this.send({
            method: "POST",
            path: "/v1/operator-action-confirmations/inspect",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/workspaces/{workspace_id}/invitations` — operationId `inviteWorkspaceMember`. */
    async inviteWorkspaceMember(request) {
        return this.send({
            method: "POST",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/invitations`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/finance/credit-notes` — operationId `issueStaffCreditNote`. */
    async issueStaffCreditNote(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/finance/credit-notes",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `GET /v1/public/widget-voice/challenge` — operationId `issueWidgetVoiceChallenge`. */
    async issueWidgetVoiceChallenge() {
        return this.send({
            method: "GET",
            path: "/v1/public/widget-voice/challenge",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/public/waitlist-signups` — operationId `joinWaitlist`. */
    async joinWaitlist(request) {
        return this.send({
            method: "POST",
            path: "/v1/public/waitlist-signups",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/me/sign-in-methods/{provider}/link` — operationId `linkMySignInMethod`. */
    async linkMySignInMethod(request) {
        return this.send({
            method: "POST",
            path: `/v1/me/sign-in-methods/${encodeURIComponent(request.path["provider"])}/link`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/api-keys` — operationId `listAccountApiKeys`. */
    async listAccountApiKeys(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/api-keys`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/audit-entries` — operationId `listAccountAuditEntries`. */
    async listAccountAuditEntries(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/audit-entries`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/invitations` — operationId `listAccountInvitations`. */
    async listAccountInvitations(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/invitations`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/members` — operationId `listAccountMembers`. */
    async listAccountMembers(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/members`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/resource-shares` — operationId `listAccountResourceShares`. */
    async listAccountResourceShares(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/resource-shares`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts` — operationId `listAccounts`. */
    async listAccounts() {
        return this.send({
            method: "GET",
            path: "/v1/accounts",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/templates` — operationId `listAgentTemplates`. */
    async listAgentTemplates() {
        return this.send({
            method: "GET",
            path: "/v1/templates",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/versions/{agent_version_id}/documents` — operationId `listAgentVersionDocuments`. */
    async listAgentVersionDocuments(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/versions/${encodeURIComponent(request.path["agent_version_id"])}/documents`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/versions` — operationId `listAgentVersions`. */
    async listAgentVersions(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/versions`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/api-keys` — operationId `listApiKeys`. */
    async listApiKeys() {
        return this.send({
            method: "GET",
            path: "/v1/api-keys",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/audit-entries` — operationId `listAuditEntries`. */
    async listAuditEntries(request) {
        return this.send({
            method: "GET",
            path: "/v1/audit-entries",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/billing-accounts` — operationId `listBillingAccounts`. */
    async listBillingAccounts(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/billing-accounts`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing/payment-methods` — operationId `listBillingPaymentMethods`. */
    async listBillingPaymentMethods() {
        return this.send({
            method: "GET",
            path: "/v1/billing/payment-methods",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing/usage` — operationId `listBillingUsage`. */
    async listBillingUsage(request) {
        return this.send({
            method: "GET",
            path: "/v1/billing/usage",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/blocked-numbers` — operationId `listBlockedNumbers`. */
    async listBlockedNumbers(request) {
        return this.send({
            method: "GET",
            path: "/v1/blocked-numbers",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/campaigns` — operationId `listCampaigns`. */
    async listCampaigns(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/campaigns`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/campaigns/{campaign_id}/skips` — operationId `listCampaignSkips`. */
    async listCampaignSkips(request) {
        return this.send({
            method: "GET",
            path: `/v1/campaigns/${encodeURIComponent(request.path["campaign_id"])}/skips`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing/charge-attempts` — operationId `listChargeAttempts`. */
    async listChargeAttempts(request) {
        return this.send({
            method: "GET",
            path: "/v1/billing/charge-attempts",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/commercial-offers` — operationId `listCommercialOffers`. */
    async listCommercialOffers(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/commercial-offers`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/connections` — operationId `listConnections`. */
    async listConnections(request) {
        return this.send({
            method: "GET",
            path: "/v1/connections",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/contact-lists/{contact_list_id}/contacts` — operationId `listContactListContacts`. */
    async listContactListContacts(request) {
        return this.send({
            method: "GET",
            path: `/v1/contact-lists/${encodeURIComponent(request.path["contact_list_id"])}/contacts`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/contact-lists` — operationId `listContactLists`. */
    async listContactLists(request) {
        return this.send({
            method: "GET",
            path: "/v1/contact-lists",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/flags` — operationId `listConversationFlags`. */
    async listConversationFlags(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/flags`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/conversations` — operationId `listConversations`. */
    async listConversations(request) {
        return this.send({
            method: "GET",
            path: "/v1/conversations",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/orders` — operationId `listCustomerOrders`. */
    async listCustomerOrders(request) {
        return this.send({
            method: "GET",
            path: "/v1/orders",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/me/domain-join-offers` — operationId `listDomainJoinOffers`. */
    async listDomainJoinOffers() {
        return this.send({
            method: "GET",
            path: "/v1/me/domain-join-offers",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/do-not-call-entries` — operationId `listDoNotCallEntries`. */
    async listDoNotCallEntries(request) {
        return this.send({
            method: "GET",
            path: "/v1/do-not-call-entries",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/financial-documents` — operationId `listFinancialDocuments`. */
    async listFinancialDocuments(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/financial-documents`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing-accounts/{billing_account_id}/funded-workspaces` — operationId `listFundedWorkspaces`. */
    async listFundedWorkspaces(request) {
        return this.send({
            method: "GET",
            path: `/v1/billing-accounts/${encodeURIComponent(request.path["billing_account_id"])}/funded-workspaces`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/gaps` — operationId `listGaps`. */
    async listGaps(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/gaps`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/help/requests` — operationId `listHelpRequests`. */
    async listHelpRequests(request) {
        return this.send({
            method: "GET",
            path: "/v1/help/requests",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing/invoices` — operationId `listInvoices`. */
    async listInvoices(request) {
        return this.send({
            method: "GET",
            path: "/v1/billing/invoices",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/languages` — operationId `listLanguagePacks`. */
    async listLanguagePacks() {
        return this.send({
            method: "GET",
            path: "/v1/languages",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/billing/ledger` — operationId `listLedgerEntries`. */
    async listLedgerEntries(request) {
        return this.send({
            method: "GET",
            path: "/v1/billing/ledger",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/conversations/live-activity` — operationId `listLiveActivity`. */
    async listLiveActivity() {
        return this.send({
            method: "GET",
            path: "/v1/conversations/live-activity",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/conversations/live` — operationId `listLiveConversations`. */
    async listLiveConversations(request) {
        return this.send({
            method: "GET",
            path: "/v1/conversations/live",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/messaging/conversations` — operationId `listMessagingConversations`. */
    async listMessagingConversations() {
        return this.send({
            method: "GET",
            path: "/v1/messaging/conversations",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/messaging/media` — operationId `listMessagingMedia`. */
    async listMessagingMedia() {
        return this.send({
            method: "GET",
            path: "/v1/messaging/media",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/me/account-closures` — operationId `listMyAccountClosures`. */
    async listMyAccountClosures() {
        return this.send({
            method: "GET",
            path: "/v1/me/account-closures",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/me/auth-sessions` — operationId `listMyAuthSessions`. */
    async listMyAuthSessions() {
        return this.send({
            method: "GET",
            path: "/v1/me/auth-sessions",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/me/sign-in-methods` — operationId `listMySignInMethods`. */
    async listMySignInMethods() {
        return this.send({
            method: "GET",
            path: "/v1/me/sign-in-methods",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/notifications` — operationId `listNotifications`. */
    async listNotifications(request) {
        return this.send({
            method: "GET",
            path: "/v1/notifications",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/numbers/requests` — operationId `listNumberRequests`. */
    async listNumberRequests() {
        return this.send({
            method: "GET",
            path: "/v1/numbers/requests",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/numbers` — operationId `listNumbers`. */
    async listNumbers() {
        return this.send({
            method: "GET",
            path: "/v1/numbers",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/optimisation-reviews` — operationId `listOptimisationReviews`. */
    async listOptimisationReviews(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/optimisation-reviews`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/phone-numbers` — operationId `listPlatformPhoneNumbers`. */
    async listPlatformPhoneNumbers() {
        return this.send({
            method: "GET",
            path: "/v1/staff/phone-numbers",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/orders-api/api/coupons` — operationId `listPortedCoupons`. */
    async listPortedCoupons() {
        return this.send({
            method: "GET",
            path: "/v1/orders-api/api/coupons",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/orders-api/api/orders` — operationId `listPortedCustomerOrders`. */
    async listPortedCustomerOrders(request) {
        return this.send({
            method: "GET",
            path: "/v1/orders-api/api/orders",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/orders-api/api/customers/{phone}/orders` — operationId `listPortedShopCustomerOrders`. */
    async listPortedShopCustomerOrders(request) {
        return this.send({
            method: "GET",
            path: `/v1/orders-api/api/customers/${encodeURIComponent(request.path["phone"])}/orders`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/orders-api/api/customers` — operationId `listPortedShopCustomers`. */
    async listPortedShopCustomers() {
        return this.send({
            method: "GET",
            path: "/v1/orders-api/api/customers",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/quota-requests` — operationId `listQuotaRequests`. */
    async listQuotaRequests() {
        return this.send({
            method: "GET",
            path: "/v1/quota-requests",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/do-not-call/refusal-phrases` — operationId `listRefusalPhrases`. */
    async listRefusalPhrases() {
        return this.send({
            method: "GET",
            path: "/v1/do-not-call/refusal-phrases",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/resource-restrictions` — operationId `listResourceRestrictions`. */
    async listResourceRestrictions(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/resource-restrictions`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/workspace/shared-agent-configurations` — operationId `listSharedVoiceAgentConfigurations`. */
    async listSharedVoiceAgentConfigurations() {
        return this.send({
            method: "GET",
            path: "/v1/workspace/shared-agent-configurations",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/sip` — operationId `listSipCredentials`. */
    async listSipCredentials() {
        return this.send({
            method: "GET",
            path: "/v1/sip",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/sip-trunks/{sip_trunk_id}/events` — operationId `listSipTrunkEvents`. */
    async listSipTrunkEvents(request) {
        return this.send({
            method: "GET",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/events`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/sip-trunks` — operationId `listSipTrunks`. */
    async listSipTrunks() {
        return this.send({
            method: "GET",
            path: "/v1/sip-trunks",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/accounts` — operationId `listStaffAccounts`. */
    async listStaffAccounts(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/accounts",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/accounts/{account_id}/sip-trunk-numbers` — operationId `listStaffAccountSipTrunkNumbers`. */
    async listStaffAccountSipTrunkNumbers(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/sip-trunk-numbers`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/approval-requests` — operationId `listStaffApprovalRequests`. */
    async listStaffApprovalRequests(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/approval-requests",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/bot-organizations` — operationId `listStaffBotOrganizationCandidates`. */
    async listStaffBotOrganizationCandidates() {
        return this.send({
            method: "GET",
            path: "/v1/staff/bot-organizations",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/payouts/exceptions` — operationId `listStaffCollectionExceptions`. */
    async listStaffCollectionExceptions(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/payouts/exceptions",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/payouts/float` — operationId `listStaffCollectionFunding`. */
    async listStaffCollectionFunding() {
        return this.send({
            method: "GET",
            path: "/v1/staff/payouts/float",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/commercial-offers` — operationId `listStaffCommercialOffers`. */
    async listStaffCommercialOffers() {
        return this.send({
            method: "GET",
            path: "/v1/staff/commercial-offers",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/flags` — operationId `listStaffConversationFlags`. */
    async listStaffConversationFlags(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/flags",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/conversations` — operationId `listStaffConversations`. */
    async listStaffConversations(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/conversations",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/cost-prices/history` — operationId `listStaffCostPriceHistory`. */
    async listStaffCostPriceHistory() {
        return this.send({
            method: "GET",
            path: "/v1/staff/cost-prices/history",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/cost-prices` — operationId `listStaffCostPrices`. */
    async listStaffCostPrices() {
        return this.send({
            method: "GET",
            path: "/v1/staff/cost-prices",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/do-not-call` — operationId `listStaffDoNotCallEntries`. */
    async listStaffDoNotCallEntries(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/do-not-call",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/finance/recent-actions` — operationId `listStaffFinanceRecentActions`. */
    async listStaffFinanceRecentActions() {
        return this.send({
            method: "GET",
            path: "/v1/staff/finance/recent-actions",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/help/conversations` — operationId `listStaffHelpConversations`. */
    async listStaffHelpConversations() {
        return this.send({
            method: "GET",
            path: "/v1/staff/help/conversations",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/help/documentation-builds` — operationId `listStaffHelpDocumentationBuilds`. */
    async listStaffHelpDocumentationBuilds() {
        return this.send({
            method: "GET",
            path: "/v1/staff/help/documentation-builds",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/help/requests` — operationId `listStaffHelpRequests`. */
    async listStaffHelpRequests(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/help/requests",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/help/unanswered` — operationId `listStaffHelpUnanswered`. */
    async listStaffHelpUnanswered(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/help/unanswered",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/live` — operationId `listStaffLiveConversations`. */
    async listStaffLiveConversations(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/live",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/number-requests` — operationId `listStaffNumberRequests`. */
    async listStaffNumberRequests(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/number-requests",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/operator-actions` — operationId `listStaffOperatorActions`. */
    async listStaffOperatorActions(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/operator-actions",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/operators/{operator_id}/capability-grants` — operationId `listStaffOperatorCapabilityGrants`. */
    async listStaffOperatorCapabilityGrants(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/operators/${encodeURIComponent(request.path["operator_id"])}/capability-grants`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/accounts/{account_id}/optimisation-reviews` — operationId `listStaffOptimisationReviews`. */
    async listStaffOptimisationReviews(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/optimisation-reviews`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/payments` — operationId `listStaffPayments`. */
    async listStaffPayments(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/payments",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/payouts/balances` — operationId `listStaffPayoutBalances`. */
    async listStaffPayoutBalances(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/payouts/balances",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/payouts/runs` — operationId `listStaffPayoutRuns`. */
    async listStaffPayoutRuns() {
        return this.send({
            method: "GET",
            path: "/v1/staff/payouts/runs",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/finance/postpaid` — operationId `listStaffPostpaidAccounts`. */
    async listStaffPostpaidAccounts() {
        return this.send({
            method: "GET",
            path: "/v1/staff/finance/postpaid",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/quota-requests` — operationId `listStaffQuotaRequests`. */
    async listStaffQuotaRequests(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/quota-requests",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/finance/refund-requests` — operationId `listStaffRefundRequests`. */
    async listStaffRefundRequests() {
        return this.send({
            method: "GET",
            path: "/v1/staff/finance/refund-requests",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/sip-trunks` — operationId `listStaffSipTrunks`. */
    async listStaffSipTrunks(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/sip-trunks",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/status/components` — operationId `listStaffStatusComponents`. */
    async listStaffStatusComponents() {
        return this.send({
            method: "GET",
            path: "/v1/staff/status/components",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/status/incidents` — operationId `listStaffStatusIncidents`. */
    async listStaffStatusIncidents() {
        return this.send({
            method: "GET",
            path: "/v1/staff/status/incidents",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/finance/vat-rates` — operationId `listStaffVatRates`. */
    async listStaffVatRates() {
        return this.send({
            method: "GET",
            path: "/v1/staff/finance/vat-rates",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/agents` — operationId `listStaffVoiceAgents`. */
    async listStaffVoiceAgents(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/agents",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/waitlist-signups` — operationId `listStaffWaitlistSignups`. */
    async listStaffWaitlistSignups() {
        return this.send({
            method: "GET",
            path: "/v1/staff/waitlist-signups",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/survey-rounds/{survey_round_id}/respondents` — operationId `listSurveyRespondents`. */
    async listSurveyRespondents(request) {
        return this.send({
            method: "GET",
            path: `/v1/survey-rounds/${encodeURIComponent(request.path["survey_round_id"])}/respondents`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/survey-rounds` — operationId `listSurveyRounds`. */
    async listSurveyRounds(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/survey-rounds`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/tiers` — operationId `listTiers`. */
    async listTiers() {
        return this.send({
            method: "GET",
            path: "/v1/tiers",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/access/entries` — operationId `listVoiceAgentAccessEntries`. */
    async listVoiceAgentAccessEntries(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/access/entries`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/channel-bindings` — operationId `listVoiceAgentChannelBindings`. */
    async listVoiceAgentChannelBindings(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/channel-bindings`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/documents` — operationId `listVoiceAgentLiveDocuments`. */
    async listVoiceAgentLiveDocuments(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/documents`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/numbers` — operationId `listVoiceAgentNumbers`. */
    async listVoiceAgentNumbers(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/numbers`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/pass-referrers` — operationId `listVoiceAgentPassReferrers`. */
    async listVoiceAgentPassReferrers(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/pass-referrers`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents` — operationId `listVoiceAgents`. */
    async listVoiceAgents() {
        return this.send({
            method: "GET",
            path: "/v1/agents",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/signalling` — operationId `listVoiceAgentSignallingEvents`. */
    async listVoiceAgentSignallingEvents(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/signalling`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/survey-results/respondents` — operationId `listVoiceAgentSurveyRespondents`. */
    async listVoiceAgentSurveyRespondents(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/survey-results/respondents`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/voices` — operationId `listVoices`. */
    async listVoices() {
        return this.send({
            method: "GET",
            path: "/v1/voices",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/webhook-endpoints/{webhook_endpoint_id}/attempts` — operationId `listWebhookDeliveryAttempts`. */
    async listWebhookDeliveryAttempts(request) {
        return this.send({
            method: "GET",
            path: `/v1/webhook-endpoints/${encodeURIComponent(request.path["webhook_endpoint_id"])}/attempts`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/webhook-endpoints` — operationId `listWebhookEndpoints`. */
    async listWebhookEndpoints(request) {
        return this.send({
            method: "GET",
            path: "/v1/webhook-endpoints",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/workspaces/{workspace_id}/api-keys` — operationId `listWorkspaceApiKeys`. */
    async listWorkspaceApiKeys(request) {
        return this.send({
            method: "GET",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/api-keys`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/workspace-lifecycle` — operationId `listWorkspaceLifecycle`. */
    async listWorkspaceLifecycle(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/workspace-lifecycle`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/workspaces/{workspace_id}/members` — operationId `listWorkspaceMembers`. */
    async listWorkspaceMembers(request) {
        return this.send({
            method: "GET",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/members`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/workspaces` — operationId `listWorkspaces`. */
    async listWorkspaces(request) {
        return this.send({
            method: "GET",
            path: "/v1/workspaces",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/staff/auth/login` — operationId `logInOperator`. */
    async logInOperator(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/auth/login",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/login` — operationId `logInPerson`. */
    async logInPerson(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/login",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/auth/logout` — operationId `logOutOperator`. */
    async logOutOperator(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/auth/logout",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/logout` — operationId `logOutPerson`. */
    async logOutPerson(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/logout",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/finance/refund-lines/{charge_attempt_id}/look-up` — operationId `lookUpStaffRefundLine`. */
    async lookUpStaffRefundLine(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/finance/refund-lines/${encodeURIComponent(request.path["charge_attempt_id"])}/look-up`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/help/requests/{help_request_id}/read` — operationId `markHelpRequestRead`. */
    async markHelpRequestRead(request) {
        return this.send({
            method: "POST",
            path: `/v1/help/requests/${encodeURIComponent(request.path["help_request_id"])}/read`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/{payout_id}/failed` — operationId `markStaffPayoutFailed`. */
    async markStaffPayoutFailed(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/${encodeURIComponent(request.path["payout_id"])}/failed`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/{payout_id}/sent` — operationId `markStaffPayoutSent`. */
    async markStaffPayoutSent(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/${encodeURIComponent(request.path["payout_id"])}/sent`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/{payout_id}/settled` — operationId `markStaffPayoutSettled`. */
    async markStaffPayoutSettled(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/${encodeURIComponent(request.path["payout_id"])}/settled`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/requests/{help_request_id}/notes` — operationId `noteStaffHelpRequest`. */
    async noteStaffHelpRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/requests/${encodeURIComponent(request.path["help_request_id"])}/notes`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/operators/{operator_id}/offboard` — operationId `offboardOperator`. */
    async offboardOperator(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/operators/${encodeURIComponent(request.path["operator_id"])}/offboard`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/agents/{voice_agent_id}/build/{build_job_id}/detail` — operationId `openStaffBuildDetail`. */
    async openStaffBuildDetail(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/agents/${encodeURIComponent(request.path["voice_agent_id"])}/build/${encodeURIComponent(request.path["build_job_id"])}/detail`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/capacity/{gpu_pool_id}/window/open` — operationId `openStaffGpuWindow`. */
    async openStaffGpuWindow(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/capacity/${encodeURIComponent(request.path["gpu_pool_id"])}/window/open`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/conversations/{conversation_id}/transcript` — operationId `openStaffLiveTranscript`. */
    async openStaffLiveTranscript(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/conversations/${encodeURIComponent(request.path["conversation_id"])}/transcript`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PATCH /v1/orders/{customer_order_reference}` — operationId `patchCustomerOrder`. */
    async patchCustomerOrder(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/orders/${encodeURIComponent(request.path["customer_order_reference"])}`,
            query: request.query,
            body: request.body,
            header: undefined,
        });
    }
    /** `PATCH /v1/orders-api/api/coupons/{coupon_code}` — operationId `patchPortedCoupon`. */
    async patchPortedCoupon(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/orders-api/api/coupons/${encodeURIComponent(request.path["coupon_code"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PATCH /v1/orders-api/api/orders/{customer_order_reference}` — operationId `patchPortedCustomerOrder`. */
    async patchPortedCustomerOrder(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/orders-api/api/orders/${encodeURIComponent(request.path["customer_order_reference"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/accounts/{account_id}/pause` — operationId `pauseStaffAccountPayouts`. */
    async pauseStaffAccountPayouts(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/accounts/${encodeURIComponent(request.path["account_id"])}/pause`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/pause` — operationId `pauseVoiceAgent`. */
    async pauseVoiceAgent(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/pause`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/billing-operations/{billing_operation_id}/pay` — operationId `payOperation`. */
    async payOperation(request) {
        return this.send({
            method: "POST",
            path: `/v1/billing-operations/${encodeURIComponent(request.path["billing_operation_id"])}/pay`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/billing-accounts/{billing_account_id}/postpaid/pay` — operationId `payPostpaid`. */
    async payPostpaid(request) {
        return this.send({
            method: "POST",
            path: `/v1/billing-accounts/${encodeURIComponent(request.path["billing_account_id"])}/postpaid/pay`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/status/incidents/{status_incident_id}/updates` — operationId `postStaffStatusIncidentUpdate`. */
    async postStaffStatusIncidentUpdate(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/status/incidents/${encodeURIComponent(request.path["status_incident_id"])}/updates`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/sign-in-policy/preflight` — operationId `previewAccountSignInPolicy`. */
    async previewAccountSignInPolicy(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/sign-in-policy/preflight`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `GET /v1/compliance/retention-policies/{class}/preview` — operationId `previewRetentionPolicy`. */
    async previewRetentionPolicy(request) {
        return this.send({
            method: "GET",
            path: `/v1/compliance/retention-policies/${encodeURIComponent(request.path["class"])}/preview`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/staff/cost-prices/impact` — operationId `previewStaffCostPriceImpact`. */
    async previewStaffCostPriceImpact(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/cost-prices/impact",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/orders/{customer_order_reference}/ticket` — operationId `printOrderTicket`. */
    async printOrderTicket(request) {
        return this.send({
            method: "POST",
            path: `/v1/orders/${encodeURIComponent(request.path["customer_order_reference"])}/ticket`,
            query: request.query,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/operators` — operationId `provisionOperator`. */
    async provisionOperator(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/operators",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/versions/{agent_version_id}/publish` — operationId `publishAgentVersion`. */
    async publishAgentVersion(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/versions/${encodeURIComponent(request.path["agent_version_id"])}/publish`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/gaps/publish` — operationId `publishAnswers`. */
    async publishAnswers(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/gaps/publish`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/optimisation-reviews/{optimisation_review_id}/publish` — operationId `publishOptimisationReview`. */
    async publishOptimisationReview(request) {
        return this.send({
            method: "POST",
            path: `/v1/optimisation-reviews/${encodeURIComponent(request.path["optimisation_review_id"])}/publish`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/help/documentation-builds/{agent_version_id}/publish` — operationId `publishStaffHelpDocumentationBuild`. */
    async publishStaffHelpDocumentationBuild(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/documentation-builds/${encodeURIComponent(request.path["agent_version_id"])}/publish`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/bot-purge` — operationId `purgeStaffBotOrganization`. */
    async purgeStaffBotOrganization(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/bot-purge`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/auth/app-auth-session/push-registration` — operationId `putAppPushRegistration`. */
    async putAppPushRegistration(request) {
        return this.send({
            method: "PUT",
            path: "/v1/auth/app-auth-session/push-registration",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/billing/auto-reload` — operationId `putAutoReloadPolicy`. */
    async putAutoReloadPolicy(request) {
        return this.send({
            method: "PUT",
            path: "/v1/billing/auto-reload",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/billing/budget` — operationId `putBudget`. */
    async putBudget(request) {
        return this.send({
            method: "PUT",
            path: "/v1/billing/budget",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/compliance/consent-lines/{medium}/{language_code}` — operationId `putConsentLine`. */
    async putConsentLine(request) {
        return this.send({
            method: "PUT",
            path: `/v1/compliance/consent-lines/${encodeURIComponent(request.path["medium"])}/${encodeURIComponent(request.path["language_code"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/accounts/{account_id}/entitlement-allocations` — operationId `putEntitlementAllocations`. */
    async putEntitlementAllocations(request) {
        return this.send({
            method: "PUT",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/entitlement-allocations`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/account/extra-time` — operationId `putExtraTime`. */
    async putExtraTime(request) {
        return this.send({
            method: "PUT",
            path: "/v1/account/extra-time",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/compliance/operator-access` — operationId `putOperatorAccess`. */
    async putOperatorAccess(request) {
        return this.send({
            method: "PUT",
            path: "/v1/compliance/operator-access",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/orders-api/api/customers/{phone}` — operationId `putPortedShopCustomer`. */
    async putPortedShopCustomer(request) {
        return this.send({
            method: "PUT",
            path: `/v1/orders-api/api/customers/${encodeURIComponent(request.path["phone"])}`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/compliance/retention-policies/{class}` — operationId `putRetentionPolicy`. */
    async putRetentionPolicy(request) {
        return this.send({
            method: "PUT",
            path: `/v1/compliance/retention-policies/${encodeURIComponent(request.path["class"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/workspaces/{workspace_id}/spend-cap` — operationId `putSpendCap`. */
    async putSpendCap(request) {
        return this.send({
            method: "PUT",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/spend-cap`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/workspaces/{workspace_id}/access-policy` — operationId `putWorkspaceAccessPolicy`. */
    async putWorkspaceAccessPolicy(request) {
        return this.send({
            method: "PUT",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/access-policy`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/accounts/{account_id}/workspace-creation-policy` — operationId `putWorkspaceCreationPolicy`. */
    async putWorkspaceCreationPolicy(request) {
        return this.send({
            method: "PUT",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/workspace-creation-policy`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/concurrency-raises` — operationId `raiseStaffAccountConcurrencyThroughApproval`. */
    async raiseStaffAccountConcurrencyThroughApproval(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/concurrency-raises`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/terms-acceptance` — operationId `readAccountTerms`. */
    async readAccountTerms(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/terms-acceptance`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/notifications/read-all` — operationId `readAllNotifications`. */
    async readAllNotifications(request) {
        return this.send({
            method: "POST",
            path: "/v1/notifications/read-all",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `GET /v1/accounts/{account_id}/billing-profile` — operationId `readBillingProfile`. */
    async readBillingProfile(request) {
        return this.send({
            method: "GET",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/billing-profile`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/connections/read-spec` — operationId `readConnectionSpec`. */
    async readConnectionSpec(request) {
        return this.send({
            method: "POST",
            path: "/v1/connections/read-spec",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `GET /v1/document-previews/{document_preview_id}` — operationId `readDocumentPreview`. */
    async readDocumentPreview(request) {
        return this.send({
            method: "GET",
            path: `/v1/document-previews/${encodeURIComponent(request.path["document_preview_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/financial-documents/{financial_document_id}` — operationId `readFinancialDocument`. */
    async readFinancialDocument(request) {
        return this.send({
            method: "GET",
            path: `/v1/financial-documents/${encodeURIComponent(request.path["financial_document_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/me/profile` — operationId `readMyProfile`. */
    async readMyProfile() {
        return this.send({
            method: "GET",
            path: "/v1/me/profile",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/online-payment/status` — operationId `readOnlinePaymentStatus`. */
    async readOnlinePaymentStatus() {
        return this.send({
            method: "GET",
            path: "/v1/online-payment/status",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/payouts/destination` — operationId `readPayoutDestination`. */
    async readPayoutDestination() {
        return this.send({
            method: "GET",
            path: "/v1/payouts/destination",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/payouts` — operationId `readPayoutStatement`. */
    async readPayoutStatement(request) {
        return this.send({
            method: "GET",
            path: "/v1/payouts",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/public/payment-links/{code}` — operationId `readPublicPaymentLink`. */
    async readPublicPaymentLink(request) {
        return this.send({
            method: "GET",
            path: `/v1/public/payment-links/${encodeURIComponent(request.path["code"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/public/status` — operationId `readPublicStatus`. */
    async readPublicStatus() {
        return this.send({
            method: "GET",
            path: "/v1/public/status",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/public/status/feed.atom` — operationId `readPublicStatusFeed`. */
    async readPublicStatusFeed() {
        return this.send({
            method: "GET",
            path: "/v1/public/status/feed.atom",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/auth/sign-in-code` — operationId `readSignInCodeAvailability`. */
    async readSignInCodeAvailability() {
        return this.send({
            method: "GET",
            path: "/v1/auth/sign-in-code",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/sip-trunk-settings` — operationId `readSipTrunkSettings`. */
    async readSipTrunkSettings() {
        return this.send({
            method: "GET",
            path: "/v1/sip-trunk-settings",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/sip-trunks/{sip_trunk_id}/test-calls` — operationId `readSipTrunkTestCall`. */
    async readSipTrunkTestCall(request) {
        return this.send({
            method: "GET",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/test-calls`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/capacity` — operationId `readStaffCapacity`. */
    async readStaffCapacity() {
        return this.send({
            method: "GET",
            path: "/v1/staff/capacity",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/conversations/totals` — operationId `readStaffConversationTotals`. */
    async readStaffConversationTotals(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/conversations/totals",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/capacity/{gpu_pool_id}/replica/add` — operationId `readStaffGpuReplicaAdd`. */
    async readStaffGpuReplicaAdd(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/capacity/${encodeURIComponent(request.path["gpu_pool_id"])}/replica/add`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/capacity/{gpu_pool_id}/replica/remove` — operationId `readStaffGpuReplicaDrain`. */
    async readStaffGpuReplicaDrain(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/capacity/${encodeURIComponent(request.path["gpu_pool_id"])}/replica/remove`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/capacity/window` — operationId `readStaffGpuWindow`. */
    async readStaffGpuWindow() {
        return this.send({
            method: "GET",
            path: "/v1/staff/capacity/window",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/help/conversations/{conversation_id}/turns` — operationId `readStaffHelpConversationTurns`. */
    async readStaffHelpConversationTurns(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/help/conversations/${encodeURIComponent(request.path["conversation_id"])}/turns`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/help/requests/{help_request_id}/page-snapshot` — operationId `readStaffHelpRequestPageSnapshot`. */
    async readStaffHelpRequestPageSnapshot(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/help/requests/${encodeURIComponent(request.path["help_request_id"])}/page-snapshot`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/help/requests/{help_request_id}/transcript` — operationId `readStaffHelpRequestTranscript`. */
    async readStaffHelpRequestTranscript(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/help/requests/${encodeURIComponent(request.path["help_request_id"])}/transcript`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/payouts/runs/{payout_run_id}` — operationId `readStaffPayoutRun`. */
    async readStaffPayoutRun(request) {
        return this.send({
            method: "GET",
            path: `/v1/staff/payouts/runs/${encodeURIComponent(request.path["payout_run_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/payouts/regulatory-sign-off` — operationId `readStaffRegulatorySignOff`. */
    async readStaffRegulatorySignOff() {
        return this.send({
            method: "GET",
            path: "/v1/staff/payouts/regulatory-sign-off",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/capacity/runtime-health` — operationId `readStaffRuntimeHealth`. */
    async readStaffRuntimeHealth() {
        return this.send({
            method: "GET",
            path: "/v1/staff/capacity/runtime-health",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/payouts/safeguarding` — operationId `readStaffSafeguarding`. */
    async readStaffSafeguarding() {
        return this.send({
            method: "GET",
            path: "/v1/staff/payouts/safeguarding",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/capacity/voicemail` — operationId `readStaffVoicemail`. */
    async readStaffVoicemail() {
        return this.send({
            method: "GET",
            path: "/v1/staff/capacity/voicemail",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/agents/{voice_agent_id}/test-calls` — operationId `readTestCall`. */
    async readTestCall(request) {
        return this.send({
            method: "GET",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/test-calls`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/test-calls/availability` — operationId `readTestCallAvailability`. */
    async readTestCallAvailability() {
        return this.send({
            method: "GET",
            path: "/v1/test-calls/availability",
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/website-reading` — operationId `readWebsiteAgain`. */
    async readWebsiteAgain(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/website-reading`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/rebuild` — operationId `rebuildVoiceAgent`. */
    async rebuildVoiceAgent(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/rebuild`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/customer-order-payment/webhooks/everypay/new-payment` — operationId `receiveCollectionWebhookNewPayment`. */
    async receiveCollectionWebhookNewPayment(request) {
        return this.send({
            method: "POST",
            path: "/v1/customer-order-payment/webhooks/everypay/new-payment",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/customer-order-payment/webhooks/everypay/notification-expired` — operationId `receiveCollectionWebhookNotificationExpired`. */
    async receiveCollectionWebhookNotificationExpired(request) {
        return this.send({
            method: "POST",
            path: "/v1/customer-order-payment/webhooks/everypay/notification-expired",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/customer-order-payment/webhooks/everypay/notification-paid` — operationId `receiveCollectionWebhookNotificationPaid`. */
    async receiveCollectionWebhookNotificationPaid(request) {
        return this.send({
            method: "POST",
            path: "/v1/customer-order-payment/webhooks/everypay/notification-paid",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/customer-order-payment/webhooks/everypay/refund` — operationId `receiveCollectionWebhookRefund`. */
    async receiveCollectionWebhookRefund(request) {
        return this.send({
            method: "POST",
            path: "/v1/customer-order-payment/webhooks/everypay/refund",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/billing/webhooks/everypay/new-payment` — operationId `receivePaymentWebhookNewPayment`. */
    async receivePaymentWebhookNewPayment(request) {
        return this.send({
            method: "POST",
            path: "/v1/billing/webhooks/everypay/new-payment",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/billing/webhooks/everypay/notification-expired` — operationId `receivePaymentWebhookNotificationExpired`. */
    async receivePaymentWebhookNotificationExpired(request) {
        return this.send({
            method: "POST",
            path: "/v1/billing/webhooks/everypay/notification-expired",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/billing/webhooks/everypay/notification-paid` — operationId `receivePaymentWebhookNotificationPaid`. */
    async receivePaymentWebhookNotificationPaid(request) {
        return this.send({
            method: "POST",
            path: "/v1/billing/webhooks/everypay/notification-paid",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/billing/webhooks/everypay/refund` — operationId `receivePaymentWebhookRefund`. */
    async receivePaymentWebhookRefund(request) {
        return this.send({
            method: "POST",
            path: "/v1/billing/webhooks/everypay/refund",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/sms/delivery-report/{account_id}/{sms_message_id}/{token}` — operationId `receiveSmsDeliveryReport`. */
    async receiveSmsDeliveryReport(request) {
        return this.send({
            method: "POST",
            path: `/v1/sms/delivery-report/${encodeURIComponent(request.path["account_id"])}/${encodeURIComponent(request.path["sms_message_id"])}/${encodeURIComponent(request.path["token"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/billing-profile/tax-id-check` — operationId `recheckStaffTaxId`. */
    async recheckStaffTaxId(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/billing-profile/tax-id-check`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/public/payment-links/{code}/placeholder-outcome` — operationId `recordPlaceholderPaymentOutcome`. */
    async recordPlaceholderPaymentOutcome(request) {
        return this.send({
            method: "POST",
            path: `/v1/public/payment-links/${encodeURIComponent(request.path["code"])}/placeholder-outcome`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/float` — operationId `recordStaffCollectionFunding`. */
    async recordStaffCollectionFunding(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/payouts/float",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/disputes` — operationId `recordStaffCustomerOrderDispute`. */
    async recordStaffCustomerOrderDispute(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/payouts/disputes",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/finance/refund-lines/{charge_attempt_id}/bank-transfer` — operationId `recordStaffRefundLineBankTransfer`. */
    async recordStaffRefundLineBankTransfer(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/finance/refund-lines/${encodeURIComponent(request.path["charge_attempt_id"])}/bank-transfer`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/regulatory-sign-off` — operationId `recordStaffRegulatorySignOff`. */
    async recordStaffRegulatorySignOff(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/payouts/regulatory-sign-off",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/settlement-credits` — operationId `recordStaffSettlementCredit`. */
    async recordStaffSettlementCredit(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/payouts/settlement-credits",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/impersonation-handoff` — operationId `redeemImpersonationHandoff`. */
    async redeemImpersonationHandoff(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/impersonation-handoff",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/auth/recovery-code` — operationId `redeemOperatorRecoveryCode`. */
    async redeemOperatorRecoveryCode(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/auth/recovery-code",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/documentation-builds` — operationId `refreshStaffHelpDocumentation`. */
    async refreshStaffHelpDocumentation(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/help/documentation-builds",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/orders/{customer_order_reference}/refunds` — operationId `refundCustomerOrder`. */
    async refundCustomerOrder(request) {
        return this.send({
            method: "POST",
            path: `/v1/orders/${encodeURIComponent(request.path["customer_order_reference"])}/refunds`,
            query: request.query,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/finance/duplicate-settlements/{billing_operation_id}/refund` — operationId `refundStaffDuplicateSettlement`. */
    async refundStaffDuplicateSettlement(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/finance/duplicate-settlements/${encodeURIComponent(request.path["billing_operation_id"])}/refund`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/me/mfa/recovery-codes` — operationId `regenerateMyRecoveryCodes`. */
    async regenerateMyRecoveryCodes(request) {
        return this.send({
            method: "POST",
            path: "/v1/me/mfa/recovery-codes",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/numbers/release` — operationId `releaseStaffAccountNumbers`. */
    async releaseStaffAccountNumbers(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/numbers/release`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/test-calls/arm/release` — operationId `releaseTestCallArm`. */
    async releaseTestCallArm(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/test-calls/arm/release`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `DELETE /v1/accounts/{account_id}/members/{account_membership_id}` — operationId `removeAccountMember`. */
    async removeAccountMember(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/members/${encodeURIComponent(request.path["account_membership_id"])}`,
            query: undefined,
            body: undefined,
            header: request.header,
        });
    }
    /** `DELETE /v1/blocked-numbers/{party_block_entry_id}` — operationId `removeBlockedNumber`. */
    async removeBlockedNumber(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/blocked-numbers/${encodeURIComponent(request.path["party_block_entry_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/do-not-call-entries/removals` — operationId `removeDoNotCallEntries`. */
    async removeDoNotCallEntries(request) {
        return this.send({
            method: "POST",
            path: "/v1/do-not-call-entries/removals",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `DELETE /v1/do-not-call-entries/{do_not_call_entry_id}` — operationId `removeDoNotCallEntry`. */
    async removeDoNotCallEntry(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/do-not-call-entries/${encodeURIComponent(request.path["do_not_call_entry_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/sip-trunks/{sip_trunk_id}/numbers/{phone_number_id}` — operationId `removeSipTrunkNumber`. */
    async removeSipTrunkNumber(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/numbers/${encodeURIComponent(request.path["phone_number_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/staff/capacity/replica/remove` — operationId `removeStaffGpuReplica`. */
    async removeStaffGpuReplica(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/capacity/replica/remove",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `DELETE /v1/agents/{voice_agent_id}/access/entries/{party_access_entry_id}` — operationId `removeVoiceAgentAccessEntry`. */
    async removeVoiceAgentAccessEntry(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/access/entries/${encodeURIComponent(request.path["party_access_entry_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/agents/{voice_agent_id}/access/entries/{party_access_entry_id}/passcode` — operationId `removeVoiceAgentAccessEntryPasscode`. */
    async removeVoiceAgentAccessEntryPasscode(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/access/entries/${encodeURIComponent(request.path["party_access_entry_id"])}/passcode`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/workspaces/{workspace_id}/members/{membership_id}` — operationId `removeWorkspaceMember`. */
    async removeWorkspaceMember(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/members/${encodeURIComponent(request.path["membership_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `PUT /v1/agents/{voice_agent_id}/name` — operationId `renameVoiceAgent`. */
    async renameVoiceAgent(request) {
        return this.send({
            method: "PUT",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/name`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PATCH /v1/agents/{voice_agent_id}/access/entries/{party_access_entry_id}` — operationId `renameVoiceAgentAccessEntry`. */
    async renameVoiceAgentAccessEntry(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/access/entries/${encodeURIComponent(request.path["party_access_entry_id"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/test-calls/arm/renew` — operationId `renewTestCallArm`. */
    async renewTestCallArm(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/test-calls/arm/renew`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/accounts/{account_id}/billing-profile` — operationId `replaceBillingProfile`. */
    async replaceBillingProfile(request) {
        return this.send({
            method: "PUT",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/billing-profile`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/contact-lists/{contact_list_id}/contacts` — operationId `replaceContactListContacts`. */
    async replaceContactListContacts(request) {
        return this.send({
            method: "PUT",
            path: `/v1/contact-lists/${encodeURIComponent(request.path["contact_list_id"])}/contacts`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/sip-trunks/{sip_trunk_id}/password` — operationId `replaceSipTrunkPassword`. */
    async replaceSipTrunkPassword(request) {
        return this.send({
            method: "PUT",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/password`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/billing-subscriptions/{billing_subscription_id}/card-replacement` — operationId `replaceSubscriptionCard`. */
    async replaceSubscriptionCard(request) {
        return this.send({
            method: "POST",
            path: `/v1/billing-subscriptions/${encodeURIComponent(request.path["billing_subscription_id"])}/card-replacement`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/messaging/media/web_chat/widgets/{channel_binding_id}/origins` — operationId `replaceWebChatWidgetOrigins`. */
    async replaceWebChatWidgetOrigins(request) {
        return this.send({
            method: "PUT",
            path: `/v1/messaging/media/web_chat/widgets/${encodeURIComponent(request.path["channel_binding_id"])}/origins`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/requests/{help_request_id}/replies` — operationId `replyStaffHelpRequest`. */
    async replyStaffHelpRequest(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/requests/${encodeURIComponent(request.path["help_request_id"])}/replies`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/quota-requests` — operationId `requestConcurrencyQuota`. */
    async requestConcurrencyQuota(request) {
        return this.send({
            method: "POST",
            path: "/v1/quota-requests",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/me/email-changes` — operationId `requestMyEmailChange`. */
    async requestMyEmailChange(request) {
        return this.send({
            method: "POST",
            path: "/v1/me/email-changes",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/password-reset` — operationId `requestPasswordReset`. */
    async requestPasswordReset(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/password-reset",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/numbers/requests` — operationId `requestPhoneNumber`. */
    async requestPhoneNumber(request) {
        return this.send({
            method: "POST",
            path: "/v1/numbers/requests",
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/auth/sign-in-code` — operationId `requestSignInCode`. */
    async requestSignInCode(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/sign-in-code",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/sip/rotation` — operationId `requestSipRotation`. */
    async requestSipRotation(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/sip/rotation`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/cost-prices/recost-requests` — operationId `requestStaffCostRecost`. */
    async requestStaffCostRecost(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/cost-prices/recost-requests",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/public/status/subscriptions` — operationId `requestStatusSubscription`. */
    async requestStatusSubscription(request) {
        return this.send({
            method: "POST",
            path: "/v1/public/status/subscriptions",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/optimisation-reviews/{optimisation_review_id}/requeue` — operationId `requeueStaffOptimisationReview`. */
    async requeueStaffOptimisationReview(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/optimisation-reviews/${encodeURIComponent(request.path["optimisation_review_id"])}/requeue`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/invitations/{account_invitation_id}/resend` — operationId `resendAccountInvitation`. */
    async resendAccountInvitation(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/invitations/${encodeURIComponent(request.path["account_invitation_id"])}/resend`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/orders/{customer_order_reference}/payment-link` — operationId `resendCustomerOrderPaymentLink`. */
    async resendCustomerOrderPaymentLink(request) {
        return this.send({
            method: "POST",
            path: `/v1/orders/${encodeURIComponent(request.path["customer_order_reference"])}/payment-link`,
            query: request.query,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/financial-documents/{financial_document_id}/resend` — operationId `resendFinancialDocument`. */
    async resendFinancialDocument(request) {
        return this.send({
            method: "POST",
            path: `/v1/financial-documents/${encodeURIComponent(request.path["financial_document_id"])}/resend`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/email-verification/resend` — operationId `resendPersonEmailVerification`. */
    async resendPersonEmailVerification(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/email-verification/resend",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/provider/confirm/resend` — operationId `resendProviderSignInCode`. */
    async resendProviderSignInCode(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/provider/confirm/resend",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/finance/document-deliveries/{financial_document_id}/resend` — operationId `resendStaffFinancialDocument`. */
    async resendStaffFinancialDocument(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/finance/document-deliveries/${encodeURIComponent(request.path["financial_document_id"])}/resend`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/flags/{conversation_flag_id}/resolve` — operationId `resolveConversationFlag`. */
    async resolveConversationFlag(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/flags/${encodeURIComponent(request.path["conversation_flag_id"])}/resolve`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/payouts/exceptions/{collection_exception_id}/resolve` — operationId `resolveStaffCollectionException`. */
    async resolveStaffCollectionException(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/exceptions/${encodeURIComponent(request.path["collection_exception_id"])}/resolve`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/disputes/{account_id}/{customer_order_dispute_id}/resolve` — operationId `resolveStaffCustomerOrderDispute`. */
    async resolveStaffCustomerOrderDispute(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/disputes/${encodeURIComponent(request.path["account_id"])}/${encodeURIComponent(request.path["customer_order_dispute_id"])}/resolve`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/refunds/{account_id}/{customer_order_refund_id}/resolve` — operationId `resolveStaffCustomerOrderRefund`. */
    async resolveStaffCustomerOrderRefund(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/refunds/${encodeURIComponent(request.path["account_id"])}/${encodeURIComponent(request.path["customer_order_refund_id"])}/resolve`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/versions/{agent_version_id}/restore` — operationId `restoreAgentVersion`. */
    async restoreAgentVersion(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/versions/${encodeURIComponent(request.path["agent_version_id"])}/restore`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/workspaces/{workspace_id}/restore` — operationId `restoreWorkspace`. */
    async restoreWorkspace(request) {
        return this.send({
            method: "POST",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/restore`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/accounts/{account_id}/resume` — operationId `resumeStaffAccountPayouts`. */
    async resumeStaffAccountPayouts(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/accounts/${encodeURIComponent(request.path["account_id"])}/resume`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/finance/operations/{billing_operation_id}/resume` — operationId `resumeStaffFinanceOperation`. */
    async resumeStaffFinanceOperation(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/finance/operations/${encodeURIComponent(request.path["billing_operation_id"])}/resume`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/resume` — operationId `resumeVoiceAgent`. */
    async resumeVoiceAgent(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/resume`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/payments/{charge_attempt_id}/retry` — operationId `retryStaffPayment`. */
    async retryStaffPayment(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payments/${encodeURIComponent(request.path["charge_attempt_id"])}/retry`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/subscription/renewal/retry` — operationId `retryStaffSubscriptionRenewal`. */
    async retryStaffSubscriptionRenewal(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/subscription/renewal/retry`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/conversations/{conversation_id}/turns/{turn_index}/reveal` — operationId `revealStaffHelpAccountReply`. */
    async revealStaffHelpAccountReply(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/conversations/${encodeURIComponent(request.path["conversation_id"])}/turns/${encodeURIComponent(request.path["turn_index"])}/reveal`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/requests/{help_request_id}/contact-reveal` — operationId `revealStaffHelpRequestContact`. */
    async revealStaffHelpRequestContact(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/requests/${encodeURIComponent(request.path["help_request_id"])}/contact-reveal`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/{payout_id}/destination-reveal` — operationId `revealStaffPayoutDestination`. */
    async revealStaffPayoutDestination(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/${encodeURIComponent(request.path["payout_id"])}/destination-reveal`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/invitations/{account_invitation_id}/revoke` — operationId `revokeAccountInvitation`. */
    async revokeAccountInvitation(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/invitations/${encodeURIComponent(request.path["account_invitation_id"])}/revoke`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `DELETE /v1/api-keys/{api_key_id}` — operationId `revokeApiKey`. */
    async revokeApiKey(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/api-keys/${encodeURIComponent(request.path["api_key_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `DELETE /v1/me/auth-sessions/{auth_session_id}` — operationId `revokeMyAuthSession`. */
    async revokeMyAuthSession(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/me/auth-sessions/${encodeURIComponent(request.path["auth_session_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/resource-shares/{resource_share_id}/revoke` — operationId `revokeResourceShare`. */
    async revokeResourceShare(request) {
        return this.send({
            method: "POST",
            path: `/v1/resource-shares/${encodeURIComponent(request.path["resource_share_id"])}/revoke`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/operators/{operator_id}/capability-grants/{capability}/revoke` — operationId `revokeStaffOperatorCapability`. */
    async revokeStaffOperatorCapability(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/operators/${encodeURIComponent(request.path["operator_id"])}/capability-grants/${encodeURIComponent(request.path["capability"])}/revoke`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `DELETE /v1/workspaces/{workspace_id}/invitations/{invitation_id}` — operationId `revokeWorkspaceInvitation`. */
    async revokeWorkspaceInvitation(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/invitations/${encodeURIComponent(request.path["invitation_id"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/api-keys/{api_key_id}/rotate` — operationId `rotateApiKey`. */
    async rotateApiKey(request) {
        return this.send({
            method: "POST",
            path: `/v1/api-keys/${encodeURIComponent(request.path["api_key_id"])}/rotate`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/auth/password` — operationId `rotateOperatorPassword`. */
    async rotateOperatorPassword(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/auth/password",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/shop/{shop_id}/counter-access-key/rotate` — operationId `rotateShopCounterAccessKey`. */
    async rotateShopCounterAccessKey(request) {
        return this.send({
            method: "POST",
            path: `/v1/shop/${encodeURIComponent(request.path["shop_id"])}/counter-access-key/rotate`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/me/onboarding-draft` — operationId `saveOnboardingDraft`. */
    async saveOnboardingDraft(request) {
        return this.send({
            method: "PUT",
            path: "/v1/me/onboarding-draft",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/billing-timezone` — operationId `scheduleAccountBillingTimezone`. */
    async scheduleAccountBillingTimezone(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/billing-timezone`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `GET /v1/staff/search` — operationId `searchStaffConsole`. */
    async searchStaffConsole(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/search",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/staff/people` — operationId `searchStaffPeople`. */
    async searchStaffPeople(request) {
        return this.send({
            method: "GET",
            path: "/v1/staff/people",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/conversations/{conversation_id}/lines` — operationId `sendStaffHelpLine`. */
    async sendStaffHelpLine(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/conversations/${encodeURIComponent(request.path["conversation_id"])}/lines`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/subscription/renewal/pay-link` — operationId `sendStaffSubscriptionPayLink`. */
    async sendStaffSubscriptionPayLink(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/subscription/renewal/pay-link`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/billing/payment-methods/{payment_method_id}/default` — operationId `setBillingDefaultPaymentMethod`. */
    async setBillingDefaultPaymentMethod(request) {
        return this.send({
            method: "POST",
            path: `/v1/billing/payment-methods/${encodeURIComponent(request.path["payment_method_id"])}/default`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/campaigns/{campaign_id}/paused` — operationId `setCampaignPaused`. */
    async setCampaignPaused(request) {
        return this.send({
            method: "PUT",
            path: `/v1/campaigns/${encodeURIComponent(request.path["campaign_id"])}/paused`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/orders/{customer_order_reference}/payment-method` — operationId `setCustomerOrderPaymentMethod`. */
    async setCustomerOrderPaymentMethod(request) {
        return this.send({
            method: "PUT",
            path: `/v1/orders/${encodeURIComponent(request.path["customer_order_reference"])}/payment-method`,
            query: request.query,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/help/page-reading` — operationId `setHelpPageReading`. */
    async setHelpPageReading(request) {
        return this.send({
            method: "PUT",
            path: "/v1/help/page-reading",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/staff/session/display-name` — operationId `setOperatorDisplayName`. */
    async setOperatorDisplayName(request) {
        return this.send({
            method: "PUT",
            path: "/v1/staff/session/display-name",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/payouts/destination` — operationId `setPayoutDestination`. */
    async setPayoutDestination(request) {
        return this.send({
            method: "PUT",
            path: "/v1/payouts/destination",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/shop/{counter_access_key}/board/wait-time` — operationId `setShopBoardWaitTime`. */
    async setShopBoardWaitTime(request) {
        return this.send({
            method: "PUT",
            path: `/v1/shop/${encodeURIComponent(request.path["counter_access_key"])}/board/wait-time`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/shop/{shop_id}/wait-time` — operationId `setShopWaitTime`. */
    async setShopWaitTime(request) {
        return this.send({
            method: "PUT",
            path: `/v1/shop/${encodeURIComponent(request.path["shop_id"])}/wait-time`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/suspension` — operationId `setStaffAccountSuspension`. */
    async setStaffAccountSuspension(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/suspension`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/flags/{conversation_flag_id}/handled` — operationId `setStaffConversationFlagHandled`. */
    async setStaffConversationFlagHandled(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/flags/${encodeURIComponent(request.path["conversation_flag_id"])}/handled`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/cost-prices` — operationId `setStaffCostPrice`. */
    async setStaffCostPrice(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/cost-prices",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/staff/help/availability` — operationId `setStaffHelpAvailability`. */
    async setStaffHelpAvailability(request) {
        return this.send({
            method: "PUT",
            path: "/v1/staff/help/availability",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/capacity/model-backup/switch` — operationId `setStaffModelBackupSwitch`. */
    async setStaffModelBackupSwitch(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/capacity/model-backup/switch",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/staff/payouts/accounts/{account_id}/online-payment-mode` — operationId `setStaffOnlinePaymentMode`. */
    async setStaffOnlinePaymentMode(request) {
        return this.send({
            method: "PUT",
            path: `/v1/staff/payouts/accounts/${encodeURIComponent(request.path["account_id"])}/online-payment-mode`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/staff/finance/postpaid/{account_id}/limit` — operationId `setStaffPostpaidLimit`. */
    async setStaffPostpaidLimit(request) {
        return this.send({
            method: "PUT",
            path: `/v1/staff/finance/postpaid/${encodeURIComponent(request.path["account_id"])}/limit`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/capacity/second-model-backup/switch` — operationId `setStaffSecondModelBackupSwitch`. */
    async setStaffSecondModelBackupSwitch(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/capacity/second-model-backup/switch",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/staff/status/components/{code}/state` — operationId `setStaffStatusComponentState`. */
    async setStaffStatusComponentState(request) {
        return this.send({
            method: "PUT",
            path: `/v1/staff/status/components/${encodeURIComponent(request.path["code"])}/state`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/finance/vat-rates` — operationId `setStaffVatRate`. */
    async setStaffVatRate(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/finance/vat-rates",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/agents/{voice_agent_id}/paused` — operationId `setStaffVoiceAgentPaused`. */
    async setStaffVoiceAgentPaused(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/agents/${encodeURIComponent(request.path["voice_agent_id"])}/paused`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/agents/{voice_agent_id}/access` — operationId `setVoiceAgentAccess`. */
    async setVoiceAgentAccess(request) {
        return this.send({
            method: "PUT",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/access`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/agents/{voice_agent_id}/access/entries/{party_access_entry_id}/passcode` — operationId `setVoiceAgentAccessEntryPasscode`. */
    async setVoiceAgentAccessEntryPasscode(request) {
        return this.send({
            method: "PUT",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/access/entries/${encodeURIComponent(request.path["party_access_entry_id"])}/passcode`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/agents/{voice_agent_id}/caller-protection` — operationId `setVoiceAgentCallerProtection`. */
    async setVoiceAgentCallerProtection(request) {
        return this.send({
            method: "PUT",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/caller-protection`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/agents/{voice_agent_id}/concurrency` — operationId `setVoiceAgentChannelUnitLimit`. */
    async setVoiceAgentChannelUnitLimit(request) {
        return this.send({
            method: "PUT",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/concurrency`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/agents/{voice_agent_id}/handoff` — operationId `setVoiceAgentHandoff`. */
    async setVoiceAgentHandoff(request) {
        return this.send({
            method: "PUT",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/handoff`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/agents/{voice_agent_id}/party-confirmation` — operationId `setVoiceAgentPartyConfirmation`. */
    async setVoiceAgentPartyConfirmation(request) {
        return this.send({
            method: "PUT",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/party-confirmation`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/agents/{voice_agent_id}/pass-targets` — operationId `setVoiceAgentPassTargets`. */
    async setVoiceAgentPassTargets(request) {
        return this.send({
            method: "PUT",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/pass-targets`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/agents/{voice_agent_id}/questionnaire-document` — operationId `setVoiceAgentQuestionnaireDocument`. */
    async setVoiceAgentQuestionnaireDocument(request) {
        return this.send({
            method: "PUT",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/questionnaire-document`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PATCH /v1/workspaces/{workspace_id}/members/{membership_id}` — operationId `setWorkspaceMemberRole`. */
    async setWorkspaceMemberRole(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}/members/${encodeURIComponent(request.path["membership_id"])}`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/me/auth-sessions/sign-out-others` — operationId `signOutMyOtherAuthSessions`. */
    async signOutMyOtherAuthSessions(request) {
        return this.send({
            method: "POST",
            path: "/v1/me/auth-sessions/sign-out-others",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/people/{person_id}/sign-out-everywhere` — operationId `signOutStaffPersonEverywhere`. */
    async signOutStaffPersonEverywhere(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/people/${encodeURIComponent(request.path["person_id"])}/sign-out-everywhere`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/signup` — operationId `signUpPerson`. */
    async signUpPerson(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/signup",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/closures` — operationId `startAccountClosure`. */
    async startAccountClosure(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/closures`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `GET /v1/auth/google/start` — operationId `startGoogleSignIn`. */
    async startGoogleSignIn(request) {
        return this.send({
            method: "GET",
            path: "/v1/auth/google/start",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `GET /v1/auth/microsoft/start` — operationId `startMicrosoftSignIn`. */
    async startMicrosoftSignIn(request) {
        return this.send({
            method: "GET",
            path: "/v1/auth/microsoft/start",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/me/mfa/totp` — operationId `startMyTotpEnrolment`. */
    async startMyTotpEnrolment(request) {
        return this.send({
            method: "POST",
            path: "/v1/me/mfa/totp",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/auth/totp-enrolment` — operationId `startOperatorTotpEnrolment`. */
    async startOperatorTotpEnrolment(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/auth/totp-enrolment",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/outbound-conversations` — operationId `startOutboundConversation`. */
    async startOutboundConversation(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/outbound-conversations`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/impersonate` — operationId `startStaffImpersonation`. */
    async startStaffImpersonation(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/impersonate`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/people/{person_id}/email-change` — operationId `startStaffPersonEmailChange`. */
    async startStaffPersonEmailChange(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/people/${encodeURIComponent(request.path["person_id"])}/email-change`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/people/{person_id}/recovery` — operationId `startStaffPersonRecovery`. */
    async startStaffPersonRecovery(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/people/${encodeURIComponent(request.path["person_id"])}/recovery`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/agents/{voice_agent_id}/build` — operationId `startVoiceAgentBuild`. */
    async startVoiceAgentBuild(request) {
        return this.send({
            method: "POST",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}/build`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/session/step-up` — operationId `stepUpAuthSession`. */
    async stepUpAuthSession(request) {
        return this.send({
            method: "POST",
            path: "/v1/session/step-up",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/auth/step-up` — operationId `stepUpOperator`. */
    async stepUpOperator(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/auth/step-up",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `GET /v1/stream/build/{build_job_id}` — operationId `streamBuildJob`. */
    async streamBuildJob(request) {
        return this.send({
            method: "GET",
            path: `/v1/stream/build/${encodeURIComponent(request.path["build_job_id"])}`,
            query: undefined,
            body: undefined,
            header: request.header,
        });
    }
    /** `GET /v1/stream/conversation/{conversation_id}/transcript` — operationId `streamConversationTranscript`. */
    async streamConversationTranscript(request) {
        return this.send({
            method: "GET",
            path: `/v1/stream/conversation/${encodeURIComponent(request.path["conversation_id"])}/transcript`,
            query: undefined,
            body: undefined,
            header: request.header,
        });
    }
    /** `GET /v1/stream/shop/{shop_id}/order` — operationId `streamShopCustomerOrder`. */
    async streamShopCustomerOrder(request) {
        return this.send({
            method: "GET",
            path: `/v1/stream/shop/${encodeURIComponent(request.path["shop_id"])}/order`,
            query: undefined,
            body: undefined,
            header: request.header,
        });
    }
    /** `GET /v1/shop/{shop_id}/order-stream` — operationId `streamShopCustomerOrderBoard`. */
    async streamShopCustomerOrderBoard(request) {
        return this.send({
            method: "GET",
            path: `/v1/shop/${encodeURIComponent(request.path["shop_id"])}/order-stream`,
            query: request.query,
            body: undefined,
            header: request.header,
        });
    }
    /** `GET /v1/stream/agent/{voice_agent_id}/live` — operationId `streamVoiceAgentLive`. */
    async streamVoiceAgentLive(request) {
        return this.send({
            method: "GET",
            path: `/v1/stream/agent/${encodeURIComponent(request.path["voice_agent_id"])}/live`,
            query: undefined,
            body: undefined,
            header: request.header,
        });
    }
    /** `GET /v1/stream/workspace/{workspace_id}/activity` — operationId `streamWorkspaceActivity`. */
    async streamWorkspaceActivity(request) {
        return this.send({
            method: "GET",
            path: `/v1/stream/workspace/${encodeURIComponent(request.path["workspace_id"])}/activity`,
            query: undefined,
            body: undefined,
            header: request.header,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/changes/{action}` — operationId `submitStaffAccountChange`. */
    async submitStaffAccountChange(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/changes/${encodeURIComponent(request.path["action"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/confirmation-code-prices/changes` — operationId `submitStaffAccountConfirmationCodePriceChange`. */
    async submitStaffAccountConfirmationCodePriceChange(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/confirmation-code-prices/changes`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/talk-rates/changes` — operationId `submitStaffAccountTalkRateChange`. */
    async submitStaffAccountTalkRateChange(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/talk-rates/changes`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/confirmation-code-prices/changes` — operationId `submitStaffConfirmationCodePriceChange`. */
    async submitStaffConfirmationCodePriceChange(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/confirmation-code-prices/changes",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/talk-rates/changes` — operationId `submitStaffStandardTalkRateChange`. */
    async submitStaffStandardTalkRateChange(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/talk-rates/changes",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `GET /v1/orders/summary` — operationId `summariseCustomerOrders`. */
    async summariseCustomerOrders(request) {
        return this.send({
            method: "GET",
            path: "/v1/orders/summary",
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/session/account` — operationId `switchAuthSessionAccount`. */
    async switchAuthSessionAccount(request) {
        return this.send({
            method: "POST",
            path: "/v1/session/account",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/conversations/{conversation_id}/takeover` — operationId `takeOverStaffHelpConversation`. */
    async takeOverStaffHelpConversation(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/conversations/${encodeURIComponent(request.path["conversation_id"])}/takeover`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/ownership-transfers` — operationId `transferAccountOwnership`. */
    async transferAccountOwnership(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/ownership-transfers`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/phone-numbers/{phone_number_id}/unassign` — operationId `unassignPlatformPhoneNumber`. */
    async unassignPlatformPhoneNumber(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/phone-numbers/${encodeURIComponent(request.path["phone_number_id"])}/unassign`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `DELETE /v1/sip-trunks/{sip_trunk_id}/numbers/{phone_number_id}/binding` — operationId `unbindSipTrunkNumber`. */
    async unbindSipTrunkNumber(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/numbers/${encodeURIComponent(request.path["phone_number_id"])}/binding`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/sip-trunks/{sip_trunk_id}/numbers/{phone_number_id}/unbind` — operationId `unbindStaffSipTrunkNumber`. */
    async unbindStaffSipTrunkNumber(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/numbers/${encodeURIComponent(request.path["phone_number_id"])}/unbind`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/closures/{account_closure_operation_id}/undo` — operationId `undoAccountClosure`. */
    async undoAccountClosure(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/closures/${encodeURIComponent(request.path["account_closure_operation_id"])}/undo`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `DELETE /v1/me/sign-in-methods/{provider}` — operationId `unlinkMySignInMethod`. */
    async unlinkMySignInMethod(request) {
        return this.send({
            method: "DELETE",
            path: `/v1/me/sign-in-methods/${encodeURIComponent(request.path["provider"])}`,
            query: undefined,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/staff/people/{person_id}/unlock` — operationId `unlockStaffPerson`. */
    async unlockStaffPerson(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/people/${encodeURIComponent(request.path["person_id"])}/unlock`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/public/status/subscriptions/unsubscription` — operationId `unsubscribeStatusSubscription`. */
    async unsubscribeStatusSubscription(request) {
        return this.send({
            method: "POST",
            path: "/v1/public/status/subscriptions/unsubscription",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PATCH /v1/accounts/{account_id}/members/{account_membership_id}` — operationId `updateAccountMember`. */
    async updateAccountMember(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/members/${encodeURIComponent(request.path["account_membership_id"])}`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PATCH /v1/accounts/{account_id}` — operationId `updateAccountProfile`. */
    async updateAccountProfile(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/accounts/{account_id}/sign-in-policy` — operationId `updateAccountSignInPolicy`. */
    async updateAccountSignInPolicy(request) {
        return this.send({
            method: "PUT",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/sign-in-policy`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PUT /v1/accounts/{account_id}/verified-domains/{sso_domain_id}/auto-join` — operationId `updateAccountVerifiedDomainAutoJoin`. */
    async updateAccountVerifiedDomainAutoJoin(request) {
        return this.send({
            method: "PUT",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/verified-domains/${encodeURIComponent(request.path["sso_domain_id"])}/auto-join`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PATCH /v1/campaigns/{campaign_id}` — operationId `updateCampaign`. */
    async updateCampaign(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/campaigns/${encodeURIComponent(request.path["campaign_id"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PATCH /v1/contact-lists/{contact_list_id}` — operationId `updateContactList`. */
    async updateContactList(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/contact-lists/${encodeURIComponent(request.path["contact_list_id"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PATCH /v1/me/profile` — operationId `updateMyProfile`. */
    async updateMyProfile(request) {
        return this.send({
            method: "PATCH",
            path: "/v1/me/profile",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PUT /v1/push-preferences` — operationId `updateMyPushPreferences`. */
    async updateMyPushPreferences(request) {
        return this.send({
            method: "PUT",
            path: "/v1/push-preferences",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PATCH /v1/sip-trunks/{sip_trunk_id}` — operationId `updateSipTrunk`. */
    async updateSipTrunk(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PATCH /v1/sip-trunks/{sip_trunk_id}/numbers/{phone_number_id}` — operationId `updateSipTrunkNumber`. */
    async updateSipTrunkNumber(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/sip-trunks/${encodeURIComponent(request.path["sip_trunk_id"])}/numbers/${encodeURIComponent(request.path["phone_number_id"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PATCH /v1/agents/{voice_agent_id}` — operationId `updateVoiceAgent`. */
    async updateVoiceAgent(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/agents/${encodeURIComponent(request.path["voice_agent_id"])}`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `PATCH /v1/messaging/media/web_chat/widgets/{channel_binding_id}` — operationId `updateWebChatWidget`. */
    async updateWebChatWidget(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/messaging/media/web_chat/widgets/${encodeURIComponent(request.path["channel_binding_id"])}`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `PATCH /v1/workspaces/{workspace_id}` — operationId `updateWorkspace`. */
    async updateWorkspace(request) {
        return this.send({
            method: "PATCH",
            path: `/v1/workspaces/${encodeURIComponent(request.path["workspace_id"])}`,
            query: undefined,
            body: request.body,
            header: request.header,
        });
    }
    /** `GET /v1/orders-api/api/coupons/{coupon_code}` — operationId `validatePortedCoupon`. */
    async validatePortedCoupon(request) {
        return this.send({
            method: "GET",
            path: `/v1/orders-api/api/coupons/${encodeURIComponent(request.path["coupon_code"])}`,
            query: request.query,
            body: undefined,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/verified-domains/{sso_domain_id}/verify` — operationId `verifyAccountVerifiedDomain`. */
    async verifyAccountVerifiedDomain(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/verified-domains/${encodeURIComponent(request.path["sso_domain_id"])}/verify`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/auth/factor` — operationId `verifyOperatorFactor`. */
    async verifyOperatorFactor(request) {
        return this.send({
            method: "POST",
            path: "/v1/staff/auth/factor",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/email-verification` — operationId `verifyPersonEmail`. */
    async verifyPersonEmail(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/email-verification",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/auth/sign-in-code/verify` — operationId `verifySignInCode`. */
    async verifySignInCode(request) {
        return this.send({
            method: "POST",
            path: "/v1/auth/sign-in-code/verify",
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/accounts/{account_id}/destination/verify` — operationId `verifyStaffPayoutDestination`. */
    async verifyStaffPayoutDestination(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/accounts/${encodeURIComponent(request.path["account_id"])}/destination/verify`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/accounts/{account_id}/subscription/periods/{billing_subscription_period_id}/waive` — operationId `waiveStaffSubscriptionPeriod`. */
    async waiveStaffSubscriptionPeriod(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/accounts/${encodeURIComponent(request.path["account_id"])}/subscription/periods/${encodeURIComponent(request.path["billing_subscription_period_id"])}/waive`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/help/conversations/{conversation_id}/watch` — operationId `watchStaffHelpConversation`. */
    async watchStaffHelpConversation(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/help/conversations/${encodeURIComponent(request.path["conversation_id"])}/watch`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/accounts/{account_id}/closures/{account_closure_operation_id}/withdraw` — operationId `withdrawAccountClosure`. */
    async withdrawAccountClosure(request) {
        return this.send({
            method: "POST",
            path: `/v1/accounts/${encodeURIComponent(request.path["account_id"])}/closures/${encodeURIComponent(request.path["account_closure_operation_id"])}/withdraw`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/staff/payouts/regulatory-sign-off/{regulatory_sign_off_id}/withdraw` — operationId `withdrawStaffRegulatorySignOff`. */
    async withdrawStaffRegulatorySignOff(request) {
        return this.send({
            method: "POST",
            path: `/v1/staff/payouts/regulatory-sign-off/${encodeURIComponent(request.path["regulatory_sign_off_id"])}/withdraw`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    /** `POST /v1/billing-subscriptions/{billing_subscription_id}/withdraw-cancellation` — operationId `withdrawSubscriptionCancellation`. */
    async withdrawSubscriptionCancellation(request) {
        return this.send({
            method: "POST",
            path: `/v1/billing-subscriptions/${encodeURIComponent(request.path["billing_subscription_id"])}/withdraw-cancellation`,
            query: undefined,
            body: request.body,
            header: undefined,
        });
    }
    async send(request) {
        const url = new URL(this.#settings.baseUrl + request.path);
        for (const [name, value] of Object.entries(request.query ?? {})) {
            if (value === undefined)
                continue;
            url.searchParams.set(name, String(value));
        }
        const header = { accept: "application/json", ...request.header };
        if (this.#settings.credential.kind === "bearer") {
            header["authorization"] = `Bearer ${this.#settings.credential.key}`;
        }
        else if (request.method !== "GET") {
            header["x-wetalk-csrf"] = this.#settings.credential.csrfToken;
        }
        if (request.body !== undefined)
            header["content-type"] = "application/json";
        // Built in two steps because `exactOptionalPropertyTypes` refuses an explicit
        // `body: undefined` where `RequestInit` declares `body?: BodyInit`.
        const init = {
            method: request.method,
            headers: header,
            credentials: this.#settings.credential.kind === "cookie" ? "include" : "omit",
        };
        if (request.body !== undefined)
            init.body = JSON.stringify(request.body);
        const response = await this.#settings.fetch(url.toString(), init);
        const text = await response.text();
        let body = null;
        if (text.length > 0) {
            try {
                body = JSON.parse(text);
            }
            catch {
                body = text;
            }
        }
        return {
            status: response.status,
            body,
            rateLimit: {
                limit: readInteger(response.headers.get("x-ratelimit-limit")),
                remaining: readInteger(response.headers.get("x-ratelimit-remaining")),
                resetAtSecond: readInteger(response.headers.get("x-ratelimit-reset")),
            },
            requestId: response.headers.get("x-wetalk-request-id"),
        };
    }
}
function readInteger(raw) {
    if (raw === null)
        return null;
    const parsed = Number.parseInt(raw, 10);
    return Number.isNaN(parsed) ? null : parsed;
}
//# sourceMappingURL=client.js.map